import { __spreadArrays, __rest, __extends, __assign } from 'tslib';
import G2 from '@antv/g2';
export { default as G2 } from '@antv/g2';
import { createElement, Component } from 'react';

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

var isArray_1 = isArray;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/** Built-in value references. */
var Symbol = _root.Symbol;

var _Symbol = Symbol;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag$1 && symToStringTag$1 in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag);
}

var isSymbol_1 = isSymbol;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray_1(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol_1(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;

/** Used to detect overreaching core-js shims. */
var coreJsData = _root['__core-js_shared__'];

var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
    objectProto$2 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString$1.call(hasOwnProperty$1).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

var _nativeCreate = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty$2.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : hasOwnProperty$3.call(data, key);
}

var _hashHas = hashHas;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

var _Hash = Hash;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

var _ListCache = ListCache;

/* Built-in method references that are verified to be native. */
var Map = _getNative(_root, 'Map');

var _Map = Map;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

var _mapCacheClear = mapCacheClear;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

var _MapCache = MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || _MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = _MapCache;

var memoize_1 = memoize;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize_1(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = _memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (isSymbol_1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

var _baseToString = baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : _baseToString(value);
}

var toString_1 = toString;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray_1(value)) {
    return value;
  }
  return _isKey(value, object) ? [value] : _stringToPath(toString_1(value));
}

var _castPath = castPath;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol_1(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

var _toKey = toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = _castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[_toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : _baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

var _stackClear = stackClear;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

var _Stack = Stack;

var defineProperty = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty = defineProperty;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty) {
    _defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue;

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq_1(object[key], value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

var _assignMergeValue = assignMergeValue;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var _createBaseFor = createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = _createBaseFor();

var _baseFor = baseFor;

var _cloneBuffer = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;
});

/** Built-in value references. */
var Uint8Array = _root.Uint8Array;

var _Uint8Array = Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray;

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var _copyArray = copyArray;

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject_1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

var _baseCreate = baseCreate;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg;

/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$5;

  return value === proto;
}

var _isPrototype = isPrototype;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !_isPrototype(object))
    ? _baseCreate(_getPrototype(object))
    : {};
}

var _initCloneObject = initCloneObject;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
}

var _baseIsArguments = baseIsArguments;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$6.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$6.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return isObjectLike_1(value) && hasOwnProperty$4.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

var isArguments_1 = isArguments;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

var isLength_1 = isLength;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}

var isArrayLike_1 = isArrayLike;

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike_1(value) && isArrayLike_1(value);
}

var isArrayLikeObject_1 = isArrayLikeObject;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

var isBuffer_1 = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse_1;

module.exports = isBuffer;
});

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto$2 = Function.prototype,
    objectProto$7 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString$2.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike_1(value) || _baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$5.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString$2.call(Ctor) == objectCtorString;
}

var isPlainObject_1 = isPlainObject;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag$1 = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag$1] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike_1(value) &&
    isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

var _baseIsTypedArray = baseIsTypedArray;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && _freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
});

/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

var isTypedArray_1 = isTypedArray;

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

var _safeGet = safeGet;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$6.call(object, key) && eq_1(objValue, value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

var _assignValue = assignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
      isArg = !isArr && isArguments_1(value),
      isBuff = !isArr && !isArg && isBuffer_1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$7.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject_1(object)) {
    return _nativeKeysIn(object);
  }
  var isProto = _isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$8.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}

var keysIn_1 = keysIn;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return _copyObject(value, keysIn_1(value));
}

var toPlainObject_1 = toPlainObject;

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = _safeGet(object, key),
      srcValue = _safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    _assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray_1(srcValue),
        isBuff = !isArr && isBuffer_1(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray_1(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray_1(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject_1(objValue)) {
        newValue = _copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = _cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = _cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject_1(srcValue) || isArguments_1(srcValue)) {
      newValue = objValue;
      if (isArguments_1(objValue)) {
        newValue = toPlainObject_1(objValue);
      }
      else if (!isObject_1(objValue) || isFunction_1(objValue)) {
        newValue = _initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  _assignMergeValue(object, key, newValue);
}

var _baseMergeDeep = baseMergeDeep;

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  _baseFor(source, function(srcValue, key) {
    stack || (stack = new _Stack);
    if (isObject_1(srcValue)) {
      _baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(_safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      _assignMergeValue(object, key, newValue);
    }
  }, keysIn_1);
}

var _baseMerge = baseMerge;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

var identity_1 = identity;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

var _apply = apply;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return _apply(func, this, otherArgs);
  };
}

var _overRest = overRest;

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

var constant_1 = constant;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !_defineProperty ? identity_1 : function(func, string) {
  return _defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant_1(string),
    'writable': true
  });
};

var _baseSetToString = baseSetToString;

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = _shortOut(_baseSetToString);

var _setToString = setToString;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return _setToString(_overRest(func, start, identity_1), func + '');
}

var _baseRest = baseRest;

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject_1(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike_1(object) && _isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq_1(object[index], value);
  }
  return false;
}

var _isIterateeCall = isIterateeCall;

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return _baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && _isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

var _createAssigner = createAssigner;

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = _createAssigner(function(object, source, srcIndex) {
  _baseMerge(object, source, srcIndex);
});

var merge_1 = merge;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

var _nativeKeys = nativeKeys;

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$9.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys;

/* Built-in method references that are verified to be native. */
var DataView = _getNative(_root, 'DataView');

var _DataView = DataView;

/* Built-in method references that are verified to be native. */
var Promise = _getNative(_root, 'Promise');

var _Promise = Promise;

/* Built-in method references that are verified to be native. */
var Set = _getNative(_root, 'Set');

var _Set = Set;

/* Built-in method references that are verified to be native. */
var WeakMap = _getNative(_root, 'WeakMap');

var _WeakMap = WeakMap;

/** `Object#toString` result references. */
var mapTag$1 = '[object Map]',
    objectTag$2 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$1 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';

var dataViewTag$1 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = _baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$1) ||
    (_Map && getTag(new _Map) != mapTag$1) ||
    (_Promise && getTag(_Promise.resolve()) != promiseTag) ||
    (_Set && getTag(new _Set) != setTag$1) ||
    (_WeakMap && getTag(new _WeakMap) != weakMapTag$1)) {
  getTag = function(value) {
    var result = _baseGetTag(value),
        Ctor = result == objectTag$2 ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$1;
        case mapCtorString: return mapTag$1;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$1;
        case weakMapCtorString: return weakMapTag$1;
      }
    }
    return result;
  };
}

var _getTag = getTag;

/** `Object#toString` result references. */
var mapTag$2 = '[object Map]',
    setTag$2 = '[object Set]';

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$c.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike_1(value) &&
      (isArray_1(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer_1(value) || isTypedArray_1(value) || isArguments_1(value))) {
    return !value.length;
  }
  var tag = _getTag(value);
  if (tag == mapTag$2 || tag == setTag$2) {
    return !value.size;
  }
  if (_isPrototype(value)) {
    return !_baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty$a.call(value, key)) {
      return false;
    }
  }
  return true;
}

var isEmpty_1 = isEmpty;

/** `Object#toString` result references. */
var numberTag$1 = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike_1(value) && _baseGetTag(value) == numberTag$1);
}

var isNumber_1 = isNumber;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return _root.Date.now();
};

var now_1 = now;

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol_1(value)) {
    return NAN;
  }
  if (isObject_1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject_1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var toNumber_1 = toNumber;

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  wait = toNumber_1(wait) || 0;
  if (isObject_1(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax$1(toNumber_1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now_1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now_1());
  }

  function debounced() {
    var time = now_1(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

var debounce_1 = debounce;

/** Error message constants. */
var FUNC_ERROR_TEXT$2 = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  if (isObject_1(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce_1(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

var throttle_1 = throttle;

var Util = G2.Util;
function is(x, y) {
    if (x === y) {
        return x !== 0 || y !== 0 || 1 / x === 1 / y;
    }
    return x !== x && y !== y; //  NaN == NaN
}
function length(obj) {
    if (Util.isArray(obj)) {
        return obj.length;
    }
    else if (Util.isObject(obj)) {
        return Object.keys(obj).length;
    }
    return 0;
}
function get$1(object, path) {
    return get_1(object, path);
}
function merge$1(object) {
    var otherArgs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        otherArgs[_i - 1] = arguments[_i];
    }
    return merge_1.apply(void 0, __spreadArrays([object], otherArgs));
}
function isEmpty$1(obj) {
    return isEmpty_1(obj);
}
function isNumber$1(obj) {
    return isNumber_1(obj);
}
function isFunction$1(obj) {
    return isFunction_1(obj);
}
function isNumeric(obj) {
    var realStringObj = obj && obj.toString();
    return !Array.isArray(obj) && realStringObj - parseFloat(realStringObj) + 1 >= 0;
}
// 只比较第一层的属性是否全等， 深层的对象不再继续比较
function shallowEqual(objA, objB) {
    if (is(objA, objB)) {
        return true;
    }
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
        return false;
    }
    if (Util.isArray(objA) !== Util.isArray(objB)) {
        return false;
    }
    if (length(objA) !== length(objB)) {
        return false;
    }
    var ret = true;
    Util.each(objA, function (v, k) {
        if (!is(v, objB[k])) {
            ret = false;
            return ret;
        }
        return true;
    });
    return ret;
}

var utils = /*#__PURE__*/Object.freeze({
	G2: G2,
	throttle: throttle_1,
	get: get$1,
	merge: merge$1,
	isEmpty: isEmpty$1,
	isNumber: isNumber$1,
	isFunction: isFunction$1,
	isNumeric: isNumeric,
	shallowEqual: shallowEqual
});

var COLORS_24 = [
    '#2196F3',
    '#2FC25B',
    '#13C2C2',
    '#66B5FF',
    '#41D9C7',
    '#6EDB8F',
    '#9AE65C',
    '#FACC14',
    '#E6965C',
    '#57AD71',
    '#F44336',
    '#738AE6',
    '#7564CC',
    '#8543E0',
    '#A877ED',
    '#5C8EE6',
    '#70E0E0',
    '#5CA3E6',
    '#3436C7',
    '#8082FF',
    '#DD81E6',
    '#F04864',
    '#FA7D92',
    '#D598D9',
];
var PIE_DEFAULT_DRAW_PADDING = [48, 48, 48, 48];

var index = /*#__PURE__*/Object.freeze({
	COLORS_24: COLORS_24,
	PIE_DEFAULT_DRAW_PADDING: PIE_DEFAULT_DRAW_PADDING
});

var yValue = function (val) { return (isNumeric(val) ? +val : null); };
function dataAdapter(data, config) {
    if (!data) {
        return [];
    }
    if (!Array.isArray(data)) {
        data = [data];
    }
    var newData = [];
    if (Array.isArray(config.yAxis)) {
        data.forEach(function (oneData) {
            if (!oneData || !Array.isArray(oneData.data)) {
                return;
            }
            var dataName = oneData.name, _a = oneData.yAxis, yIndex = _a === void 0 ? 0 : _a, visible = oneData.visible, groupExtra = __rest(oneData, ["name", "yAxis", "visible"]);
            oneData.data.forEach(function (d, i) {
                var _a, _b, _c;
                if (Array.isArray(d)) {
                    var x = d[0], y = d[1], extra = d.slice(2);
                    newData.push((_a = {
                            x: x
                        },
                        _a["y" + yIndex] = yValue(y),
                        _a.extra = extra,
                        _a.groupExtra = groupExtra,
                        _a.visible = visible,
                        _a.type = dataName,
                        _a));
                }
                else if (config.xAxis && config.xAxis.categories && config.xAxis.categories[i]) {
                    var x = config.xAxis.categories[i];
                    var y = isNaN(d) ? d[0] : d;
                    newData.push((_b = {
                            x: x
                        },
                        _b["y" + yIndex] = yValue(y),
                        _b.extra = [],
                        _b.groupExtra = groupExtra,
                        _b.visible = visible,
                        _b.type = dataName,
                        _b));
                }
                else {
                    var x = d.x, y = d.y, extra = __rest(d, ["x", "y"]);
                    newData.push((_c = {
                            x: x
                        },
                        _c["y" + yIndex] = yValue(y),
                        _c.extra = extra,
                        _c.groupExtra = groupExtra,
                        _c.visible = visible,
                        _c.type = dataName,
                        _c));
                }
            });
        });
    }
    else {
        data.forEach(function (oneData) {
            if (!oneData || !Array.isArray(oneData.data)) {
                return;
            }
            var dataName = oneData.name, facet = oneData.facet, dodge = oneData.dodge, visible = oneData.visible, groupExtra = __rest(oneData, ["name", "facet", "dodge", "visible"]);
            oneData.data.forEach(function (d, i) {
                if (Array.isArray(d)) {
                    var x = d[0], y = d[1], extra = d.slice(2);
                    newData.push({
                        x: x,
                        y: yValue(y),
                        extra: extra,
                        groupExtra: groupExtra,
                        facet: facet,
                        dodge: dodge,
                        visible: visible,
                        type: dataName,
                    });
                }
                else if (config.xAxis && config.xAxis.categories && config.xAxis.categories[i]) {
                    var x = config.xAxis.categories[i];
                    var y = isNaN(d) ? d[0] : d;
                    newData.push({
                        x: x,
                        y: yValue(y),
                        extra: [],
                        groupExtra: groupExtra,
                        facet: facet,
                        dodge: dodge,
                        visible: visible,
                        type: dataName,
                    });
                }
                else {
                    var x = d.x, y = d.y, extra = __rest(d, ["x", "y"]);
                    newData.push({
                        x: x,
                        y: yValue(y),
                        extra: extra,
                        groupExtra: groupExtra,
                        facet: facet,
                        dodge: dodge,
                        visible: visible,
                        type: dataName,
                    });
                }
            });
        });
    }
    return newData;
}

var requestAnimationFrame = window && window.requestAnimationFrame;
var propertyMap = {
    xAxis: [
        'type',
        'alias',
        'range',
        'ticks',
        'tickCount',
        'tickInterval',
        'formatter',
        'min',
        'max',
        'minLimit',
        'maxLimit',
        'nice',
        'values',
        'mask',
        'base',
        'exponent',
        'sync',
    ],
    yAxis: [
        'type',
        'alias',
        'range',
        'ticks',
        'tickCount',
        'tickInterval',
        'formatter',
        'min',
        'max',
        'minLimit',
        'maxLimit',
        'nice',
        'values',
        'mask',
        'base',
        'exponent',
        'sync',
    ],
};
var keyType = {
    min: 'number',
    max: 'number',
    minLimit: 'number',
    maxLimit: 'number',
    tickCount: 'number',
};
function propertyAssign(keys, target, source) {
    if (!source) {
        return target;
    }
    keys.forEach(function (key) {
        // 仅判断undefined的情况
        if (source[key] !== undefined) {
            // 将部分限制了类型的key属性转换为需要的类型
            if (keyType[key] !== 'number') {
                target[key] = source[key];
            }
            else if (source[key] === null) {
                // 设置null则直接赋值
                target[key] = null;
            }
            else if (!isInvalidNumber(source[key])) {
                // 是数字时才赋值，否则直接跳过
                target[key] = Number(source[key]);
            }
        }
    });
    return target;
}
/**
 * 找到对应元素的父元素的大小
 *
 * @param {element} element Html元素
 * @param {number} width props中传递的width属性
 * @param {number} height props中传递的height属性
 *
 * @return {array} 宽和高的数组
 * */
function getParentSize(element, width, height) {
    var w = width || '';
    var h = height || '';
    var parent = element && element.parentElement;
    if (parent) {
        var parentStyle = window.getComputedStyle(parent);
        var paddingTop = pxToNumber(parentStyle.getPropertyValue('padding-top'));
        var paddingRight = pxToNumber(parentStyle.getPropertyValue('padding-right'));
        var paddingBottom = pxToNumber(parentStyle.getPropertyValue('padding-bottom'));
        var paddingLeft = pxToNumber(parentStyle.getPropertyValue('padding-left'));
        if (!width) {
            w = parent.clientWidth - paddingLeft - paddingRight;
        }
        if (!height) {
            h = parent.clientHeight - paddingTop - paddingBottom;
        }
    }
    return [w, h];
}
function pxToNumber(px) {
    return Number(px.replace('px', ''));
}
function getFinalGeomColors(rawData, consoleTheme, colorGroup) {
    if (colorGroup === void 0) { colorGroup = 'colors_24'; }
    var colors = [];
    if (get$1(rawData, '0.color')) {
        colors = rawData.map(function (v) { return v.color; });
    }
    else {
        var colors24 = get$1(consoleTheme, colorGroup);
        if (colors24) {
            colors = colors24;
        }
        else {
            colors = COLORS_24;
        }
    }
    return colors;
}
/**
 * 从Highcharts格式数据中找到对应index的颜色
 *
 * @param {array} colors 颜色数组
 * @param {array} rawData Highcharts 格式的数据
 * @param {number} dataIndex y轴对应的index
 * */
function getDataIndexColor(colors, rawData, dataIndex) {
    var colorIndex = null;
    // 找到第一个顺序值和数据中yAxis值匹配的index
    rawData.forEach(function (d, i) {
        var dataYAxisIndex = d.yAxis;
        if (dataYAxisIndex === dataIndex) {
            colorIndex = i;
        }
    });
    if (colorIndex !== null) {
        return colors[colorIndex];
    }
}
var statusMap = {};
function getStatusColor(status) {
    return statusMap[status] || status || statusMap.normal;
}
var statusColorMap = {
    error: 'red',
    warning: 'orange',
    normal: 'blue',
    success: 'green',
    none: 'gray',
};
function getStatusColorName(status) {
    return statusColorMap[status] || status || statusColorMap.normal;
}
/**
 * 判断是否是有效数字
 *
 * @param v 输入值
 *
 * @return {boolean} 是否有效数字
 * */
function isInvalidNumber(v) {
    return isNaN(v) || !isFinite(v) || v === '' || typeof v === 'object';
}
/**
 * 数字格式化小数位
 *
 * @param {number} num 输入数字
 * @param {number} decimal 小数位数，默认两位
 *
 * @return {string|number} 如果不是数字，返回横杠字符串。如果是数字，返回设定小数位的字符串。
 * */
function numberDecimal(num, decimal) {
    if (decimal === void 0) { decimal = 2; }
    if (isInvalidNumber(num) || isInvalidNumber(decimal)) {
        return '-';
    }
    return Math.round(Number(num) * Math.pow(10, decimal)) / Math.pow(10, decimal);
}
/**
 * 数字格式化千分位
 *
 * @param {number} num 输入数字
 * @param {number} char 分隔符，默认为逗号
 *
 * @return {string|number} 如果不是数字，返回横杠字符串。如果是数字，返回千分位的字符串。
 * */
function beautifyNumber(num, char) {
    if (char === void 0) { char = ','; }
    if (isInvalidNumber(num)) {
        return '-';
    }
    var isNegative = num < 0;
    var numberArr = num.toString().split('.');
    var number = numberArr[0].replace('-', '');
    var result = '';
    while (number.length > 3) {
        result = char + number.slice(-3) + result;
        number = number.slice(0, number.length - 3);
    }
    if (number) {
        result = number + result;
    }
    // fix 保留了小数位数字
    if (numberArr[1]) {
        result = result + "." + numberArr[1];
    }
    // 处理负数
    if (isNegative) {
        result = "-" + result;
    }
    return result;
}
// 规范化padding输出
function formatPadding(val) {
    var output = null;
    var defaultOutput = [0, 0, 0, 0];
    if (Array.isArray(val) && val.length === 4) {
        var len = val.length;
        switch (len) {
            case 1:
                output = new Array(4).fill(val[0]);
                break;
            case 2:
                output = val.concat(val);
                break;
            case 4:
                output = val;
                break;
            default:
                output = defaultOutput;
                break;
        }
    }
    else if (!isInvalidNumber(val)) {
        output = new Array(4).fill(val);
    }
    else {
        output = defaultOutput;
    }
    return output;
}
function stylePadding(val) {
    var formattedPadding = formatPadding(val);
    var stylePadding = { paddingTop: '', paddingRight: '', paddingBottom: '', paddingLeft: '' };
    stylePadding.paddingTop = formattedPadding[0] + "px";
    stylePadding.paddingRight = formattedPadding[1] + "px";
    stylePadding.paddingBottom = formattedPadding[2] + "px";
    stylePadding.paddingLeft = formattedPadding[3] + "px";
    return stylePadding;
}
/**
 * 空函数
 * */
function noop() { }
/**
 * tooltip item 获取原始数据
 *
 * @param {object} config 图表配置项
 * @param {array} rawData 挂载于 this.rawData 上的原始数据
 * @param {number} item tooltip格式化函数的当前数据项
 *
 * @return {object} 寻找得到的原始数据，没有找到则返回空对象。
 * */
function getRawData(config, rawData, item) {
    if (!rawData) {
        return {};
    }
    var originData = (item.point && item.point._origin) || {};
    if (config.dataType !== 'g2' && Array.isArray(rawData)) {
        rawData.some(function (r) {
            if (r.name === originData.type) {
                // 如果原数据中定义了 facet，需要额外判定 facet 字段
                if (r.facet && originData.facet !== r.facet) {
                    return false;
                }
                originData = r;
                return true;
            }
            return false;
        });
    }
    return originData;
}
/**
 * 过滤对象中的key，常用于过滤传递给div的props，防止react invalid attribute warning
 *
 * @param {object} obj 过滤的对象
 * @param {array} keys 过滤的键列表
 *
 * @return {object} 过滤后的结果
 * */
function filterKey(obj, keys) {
    var result = {};
    Object.keys(obj).forEach(function (key) {
        if (keys.indexOf(key) === -1) {
            result[key] = obj[key];
        }
    });
    return result;
}
/**
 * 处理图表库中的默认padding值的通用函数
 *
 * @param {padding} padding 用户配置的padding值
 * @param {object} config 合并了默认配置后的最终配置项
 * 以下参数非必选
 * @param {number} [defaultTop] 默认top padding
 * @param {number} [defaultRight] 默认right padding
 * @param {number} [defaultBottom] 默认bottom padding
 * @param {number} [defaultLeft] 默认left padding
 *
 * @return
 * */
function defaultPadding(padding, config, defaultTop, defaultRight, defaultBottom, defaultLeft) {
    if (padding) {
        return padding;
    }
    // 取默认配置中的padding
    var top = defaultTop;
    var right = defaultRight;
    var bottom = defaultBottom;
    var left = defaultLeft;
    if (right !== 'auto' && Array.isArray(config.yAxis)) {
        right = 45;
    }
    if (top !== 'auto' && config.legend === false) {
        top = 16;
    }
    if (config.legend !== false) {
        var _a = config.legend || {}, _b = _a.position, position = _b === void 0 ? 'top' : _b, _c = _a.attachLast, attachLast = _c === void 0 ? false : _c;
        if (top !== 'auto' && position === 'bottom') {
            top = 10;
            if (config.topUnit) {
                top = 30;
            }
        }
        if (bottom !== 'auto' && position === 'bottom') {
            // 使用底部padding的位置放置 legend
            bottom = 60;
        }
        if (attachLast) {
            // 图例跟随
            right = 120;
        }
    }
    // X轴标题
    if (config.xAxis && config.xAxis.visible !== false && config.xAxis.alias && bottom !== 'auto') {
        bottom += 14;
    }
    // Y轴标题
    if (Array.isArray(config.yAxis)) {
        config.yAxis.forEach(function (axis, yIndex) {
            if (yIndex === 0 && axis && axis.visible !== false && axis.alias && left !== 'auto') {
                left += 20;
            }
            if (yIndex !== 0 && axis && axis.visible !== false && axis.alias && right !== 'auto') {
                right += 20;
            }
        });
    }
    else if (config.yAxis &&
        config.yAxis.visible !== false &&
        config.yAxis.alias &&
        left !== 'auto') {
        left += 20;
    }
    return [top, right, bottom, left];
}
/**
 * 处理图表库中的默认padding值的通用函数
 *
 * @param {padding} padding 用户配置的padding值
 * @param {object} config 合并了默认配置后的最终配置项
 * @return
 * */
function computePadding(padding, config) {
    if (padding) {
        return padding;
    }
    var configPadding = config.padding;
    // 取默认配置中的padding
    if (!Array.isArray(configPadding)) {
        console.error('Padding 必须为[paddingTop, paddingRight, paddingBottom, paddingLeft]格式');
    }
    var top = configPadding[0];
    var right = configPadding[1];
    var bottom = configPadding[2];
    var left = configPadding[3];
    if (right !== 'auto' && Array.isArray(config.yAxis)) {
        right = 45;
    }
    if (top !== 'auto' && config.legend === false) {
        top = 16;
    }
    if (config.legend !== false) {
        var _a = config.legend || {}, _b = _a.position, position = _b === void 0 ? 'top' : _b, _c = _a.attachLast, attachLast = _c === void 0 ? false : _c;
        if (top !== 'auto' && position === 'bottom') {
            top = 10;
            if (config.topUnit) {
                top = 30;
            }
        }
        if (bottom !== 'auto' && position === 'bottom') {
            // 使用底部padding的位置放置 legend
            bottom = 60;
        }
        if (attachLast) {
            // 图例跟随
            right = 120;
        }
    }
    // X轴标题
    if (config.xAxis && config.xAxis.visible !== false && config.xAxis.alias && bottom !== 'auto') {
        bottom += 14;
    }
    // Y轴标题
    if (Array.isArray(config.yAxis)) {
        config.yAxis.forEach(function (axis, yIndex) {
            if (yIndex === 0 && axis && axis.visible !== false && axis.alias && left !== 'auto') {
                left += 20;
            }
            if (yIndex !== 0 && axis && axis.visible !== false && axis.alias && right !== 'auto') {
                right += 20;
            }
        });
    }
    else if (config.yAxis &&
        config.yAxis.visible !== false &&
        config.yAxis.alias &&
        left !== 'auto') {
        left += 20;
    }
    return [top, right, bottom, left];
}
function adaptData(needAdapte, data, config) {
    if (needAdapte === void 0) { needAdapte = true; }
    var adaptData = needAdapte && config.dataType !== 'g2' ? dataAdapter(data, config) : data;
    return adaptData;
}

/**
 * 常见直角坐标系自动计算标签个数。
 * @param chart {object} G2图表实例
 * @param config {object} 图表配置项
 * @param defs {object} 数据列定义
 * @param transpose {boolean} 坐标系是否翻转，翻转后使用宽度计算Y轴，高度计算X轴
 * */
function rectAutoTickCount(chart, config, defs, transpose) {
    // X轴&Y轴对应的长度
    var xLen = transpose ? chart.get('height') : chart.get('width');
    var yLen = transpose ? chart.get('width') : chart.get('height');
    // 坐标系不翻转时为横向，翻转时为纵向
    computerAxis(chart, config.xAxis, defs.x, transpose, xLen);
    // 坐标系不翻转时为纵向，翻转时为横向
    if (Array.isArray(config.yAxis)) {
        config.yAxis.forEach(function (axis, yIndex) {
            computerAxis(chart, axis, defs["y" + yIndex], !transpose, yLen);
        });
    }
    else {
        computerAxis(chart, config.yAxis, defs.y, !transpose, yLen);
    }
}
// 计算口径 horizontal 横向 ? vertical 纵向
function computerAxis(chart, axisConfig, def, isVertical, len) {
    // 轴设定为不显示 或 tickCount 不是 auto 时，跳过
    if (!axisConfig ||
        (axisConfig && axisConfig.visible === false) ||
        axisConfig.tickCount !== 'auto') {
        return;
    }
    var labelFontSize = pxToNumber('12px');
    if (axisConfig.customConfig &&
        axisConfig.customConfig.label &&
        axisConfig.customConfig.label.textStyle &&
        axisConfig.customConfig.label.textStyle.fontSize) {
        labelFontSize = convertFontSize(axisConfig.customConfig.label.textStyle.fontSize);
    }
    var tickCount = 0;
    if (isVertical) {
        // 纵向，使用高度计算，除数为 一倍的字体大小 + 三分之四倍字号作为间距
        // TODO 需要减去上下padding
        tickCount = Math.max(Math.floor((len - 20) / ((labelFontSize * 8) / 3)), 2);
    }
    else if (def.type === 'time' || def.type === 'timeCat') {
        // 横向，使用宽度计算，仅支持time类型，取mask的字符长度 * 0.5倍字号作为标签宽度，再乘1.5倍作为除数
        var labelWidth = ((def.mask || 'YYYY-MM-DD HH:mm:ss').length * labelFontSize) / 2;
        tickCount = Math.max(Math.floor(len / ((labelWidth * 3) / 2)), 2);
    }
    if (tickCount) {
        console.log(tickCount);
        def.tickCount = tickCount;
    }
}
function convertFontSize(fontSize) {
    var size = fontSize;
    if (typeof size === 'string') {
        size = size.replace('px', '');
    }
    if (isInvalidNumber(size)) {
        return pxToNumber('12px');
    }
    else {
        return Number(size);
    }
}

// 通用坐标轴配置
function axisX (chart, config, componentConfig) {
    if (config.xAxis === false || (config.xAxis && config.xAxis.visible === false)) {
        chart.axis('x', false);
    }
    else {
        var _a = config.xAxis || {}, grid = _a.grid, _b = _a.title, title = _b === void 0 ? false : _b, _c = _a.autoRotate, _d = _a.rotate, rotate = _d === void 0 ? false : _d, other = __rest(_a, ["grid", "title", "autoRotate", "rotate"]);
        var xAxisConfig = other;
        if (rotate) {
            if (!xAxisConfig.label)
                xAxisConfig.label = {};
            xAxisConfig.label.textStyle = {
                textAlign: 'start',
                rotate: rotate,
            };
        }
        // 网格线
        if (grid) {
            if (grid === true) {
                xAxisConfig.grid = {
                    lineStyle: {
                        lineWidth: 1,
                    },
                };
            }
            else {
                xAxisConfig.grid = Object.assign({}, grid);
            }
        }
        // 开启坐标轴标题
        if (title) {
            if (title === true) {
                xAxisConfig.title = {
                    position: 'center',
                    offset: 38,
                    textStyle: {
                        rotate: 0,
                    },
                };
            }
            else {
                xAxisConfig.title = Object.assign({}, title);
            }
        }
        if (componentConfig) {
            Object.assign(xAxisConfig, componentConfig);
        }
        chart.axis('x', xAxisConfig);
    }
}

/*
 * 常见直角坐标系的单个Y轴设置。
 * */
function axisY (chart, config, yField, componentConfig) {
    yField = yField || 'y';
    if (config.yAxis === false || get$1(config, 'yAxis.visible') === false) {
        chart.axis(yField, false);
        return;
    }
    else {
        var _a = config.yAxis || {}, _b = _a.title, title = _b === void 0 ? false : _b, _c = _a.formatter, line = _a.line, other = __rest(_a, ["title", "formatter", "line"]);
        var yAxisConfig = other;
        // 关闭了X轴，需要显示第一条grid
        if (config.xAxis === false || get$1(config, 'xAxis.visible') === false) {
            yAxisConfig.grid = {
                hideFirstLine: false,
            };
        }
        // 开启坐标轴标题
        if (title) {
            if (title === true) {
                yAxisConfig.title = {
                    position: 'center',
                    // offset: 30,
                    textStyle: {
                        rotate: -90,
                    },
                };
            }
            else {
                yAxisConfig.title = Object.assign({}, title);
            }
            // 如果存在右侧坐标轴，调整旋转方向
            if (yField === 'y1') {
                yAxisConfig.title.textStyle.rotate = 90;
            }
            yAxisConfig.label.textStyle = {
                rotate: 0,
            };
        }
        if (componentConfig) {
            Object.assign(yAxisConfig, componentConfig);
        }
        chart.axis(yField, yAxisConfig);
    }
}

/** `Object#toString` result references. */
var stringTag$1 = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray_1(value) && isObjectLike_1(value) && _baseGetTag(value) == stringTag$1);
}

var isString_1 = isString;

function label(geom, config, labelConfig, yField, callbackYField, extras) {
    if (yField === void 0) { yField = 'y'; }
    if (callbackYField === void 0) { callbackYField = 'x*y*type*facet'; }
    if (extras === void 0) { extras = {}; }
    if (!labelConfig || get$1(labelConfig, 'visible') === false) {
        return;
    }
    if (isString_1(labelConfig)) {
        geom.label(labelConfig);
    }
    else if (isPlainObject_1(labelConfig)) {
        var newLabelConfig = Object.assign({}, labelConfig);
        var formatter_1 = newLabelConfig.formatter;
        if (formatter_1) {
            newLabelConfig.formatter = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return formatter_1.apply(void 0, __spreadArrays(args, [extras]));
            };
        }
        geom.label(yField, newLabelConfig);
    }
    else if (isFunction$1(labelConfig)) {
        var newFunc = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return labelConfig.apply(void 0, __spreadArrays(args, [extras]));
        };
        geom.label(callbackYField, newFunc);
    }
    else if (Array.isArray(labelConfig)) {
        var finalField_1 = null;
        var finalCallback_1 = null;
        var finalCfg_1 = null;
        labelConfig.forEach(function (v) {
            if (isString_1(v)) {
                finalField_1 = v;
            }
            else if (isPlainObject_1(v)) {
                finalCfg_1 = Object.assign({}, v);
            }
            else if (isFunction$1(v)) {
                finalCallback_1 = v;
            }
        });
        finalField_1 = finalField_1 ? finalField_1 : callbackYField;
        if (finalCallback_1) {
            geom.label(finalField_1, function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return finalCallback_1.apply(void 0, __spreadArrays(args, [extras]));
            }, finalCfg_1);
        }
        else {
            if (finalCfg_1 && finalCfg_1.formatter) {
                var formatter_2 = finalCfg_1.formatter;
                finalCfg_1.formatter = function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    return formatter_2.apply(void 0, __spreadArrays(args, [extras]));
                };
            }
            geom.label(finalField_1, finalCfg_1);
        }
    }
}

function g2Size (geom, config, sizeConfig, yField, callbackYField) {
    if (yField === void 0) { yField = 'type'; }
    if (callbackYField === void 0) { callbackYField = 'x*y*type*facet'; }
    if (!sizeConfig) {
        return;
    }
    if (Array.isArray(sizeConfig)) {
        if (isNumber$1(sizeConfig[0] && isNumber$1(sizeConfig[1]))) {
            geom.size(yField, sizeConfig);
        }
        else {
            geom.size.apply(geom, sizeConfig);
        }
    }
    else if (isFunction$1(sizeConfig)) {
        geom.size(callbackYField, sizeConfig);
    }
    else {
        geom.size(sizeConfig);
    }
}

// 标准style函数
// https://www.yuque.com/antv/g2-docs/api-geom#style
function g2Style (gemo, config, styleConfig) {
    if (!styleConfig) {
        return;
    }
    var formatStyleConfig = Array.isArray(styleConfig) ? styleConfig : [styleConfig];
    gemo.style.apply(gemo, formatStyleConfig);
}

function drawLine(chart, config, yAxisKey) {
    if (yAxisKey === void 0) { yAxisKey = 'y'; }
    var lineGeom = null;
    var lineShape = config.smooth ? 'smooth' : 'line';
    var areaShape = config.smooth ? 'smooth' : 'area';
    var clrsOne = [];
    var clrsTwo = [];
    (config.colors || []).forEach(function (x) {
        if (Array.isArray(x)) {
            clrsOne.push(x[0]);
            clrsTwo.push(x[1]);
        }
        else if (typeof x === 'string') {
            clrsOne.push(x);
            clrsTwo.push(x);
        }
    });
    if (config.area && config.stack) {
        chart
            .areaStack()
            .position(['x', yAxisKey])
            .color('type', clrsTwo)
            .shape(areaShape)
            .active(false);
        lineGeom = chart
            .lineStack()
            .position(['x', yAxisKey])
            .color('type', clrsOne)
            .shape(lineShape)
            .active(false);
    }
    else if (config.area && !config.stack) {
        chart
            .area()
            .position(['x', yAxisKey])
            .color('type', clrsTwo)
            .shape(areaShape)
            .active(false);
        lineGeom = chart
            .line()
            .position(['x', yAxisKey])
            .color('type', clrsOne)
            .shape(lineShape)
            .active(false);
    }
    else {
        lineGeom = chart
            .line()
            .position(['x', yAxisKey])
            .color('type', clrsOne)
            .shape(lineShape)
            .active(false);
    }
    g2Size(lineGeom, config, config.lineSize || config.size);
    label(lineGeom, config, config.label, yAxisKey);
    g2Style(lineGeom, config, config.style);
    // 曲线默认点
    var pointGeom = null;
    if (config.symbol) {
        if (config.area && config.stack) {
            pointGeom = chart
                .point()
                .adjust('stack')
                .position(['x', yAxisKey])
                .color('type', config.colors)
                .shape('circle')
                .active(false);
        }
        else {
            pointGeom = chart
                .point()
                .position(['x', yAxisKey])
                .color('type', config.colors)
                .shape('circle')
                .active(false);
        }
        g2Size(pointGeom, config, config.symbolSize || config.size, 'type', 'x*y*type*extra');
        label(pointGeom, config, config.symbolLabel);
        g2Style(pointGeom, config, config.symbolStyle);
    }
}

var sortFun = {
    // 升序
    asc: function (a, b) {
        return a.value - b.value;
    },
    // 降序
    desc: function (a, b) {
        return b.value - a.value;
    }
};
function tooltip(chart, config, configTooltip, specConfig) {
    if (specConfig === void 0) { specConfig = null; }
    if (configTooltip === false || get$1(configTooltip, "visible") === false) {
        chart.tooltip(false);
        return;
    }
    var finalConfigTooltip = Object.assign({}, configTooltip, specConfig);
    chart.tooltip(finalConfigTooltip);
    var sort = get$1(finalConfigTooltip, "sort");
    if (sort) {
        chart.on("tooltip:change", function (ev) {
            // 如果设置了合法的排序关键字，则开始排序
            if (isFunction$1(sort)) {
                ev.items.sort(sort);
            }
            else if (sortFun[sort]) {
                ev.items.sort(sortFun[sort]);
            }
        });
    }
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED$2);
  return this;
}

var _setCacheAdd = setCacheAdd;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new _MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd;
SetCache.prototype.has = _setCacheHas;

var _SetCache = SetCache;

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

var _baseFindIndex = baseFindIndex;

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

var _baseIsNaN = baseIsNaN;

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

var _strictIndexOf = strictIndexOf;

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? _strictIndexOf(array, value, fromIndex)
    : _baseFindIndex(array, _baseIsNaN, fromIndex);
}

var _baseIndexOf = baseIndexOf;

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && _baseIndexOf(array, value, 0) > -1;
}

var _arrayIncludes = arrayIncludes;

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

var _arrayIncludesWith = arrayIncludesWith;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin$1 = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? _arrayIncludesWith : _arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = _arrayMap(array, _baseUnary(iteratee));
    }
    maxLength = nativeMin$1(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new _SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? _cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? _cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

var _baseIntersection = baseIntersection;

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject_1(value) ? value : [];
}

var _castArrayLikeObject = castArrayLikeObject;

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = _baseRest(function(arrays) {
  var mapped = _arrayMap(arrays, _castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? _baseIntersection(mapped)
    : [];
});

var intersection_1 = intersection;

var allowedFunctions = [
    'line',
    'text',
    'image',
    'region',
    'html',
    'arc',
    'regionFilter',
    'dataMarker',
    'dataRegion',
];
function guide(chart, config, guideConfig) {
    if (!isPlainObject_1(guideConfig)) {
        return;
    }
    // 横向的，不允许展示topUnit属性
    if (config.horizontal) {
        guideConfig.topUnit = false;
    }
    var topUnit = guideConfig.topUnit, other = __rest(guideConfig, ["topUnit"]);
    var configKeys = Object.keys(other || {});
    var intersectionKeys = intersection_1(configKeys, allowedFunctions);
    intersectionKeys.forEach(function (key) {
        if (Array.isArray(other[key])) {
            other[key].forEach(function (config) { return chart.guide()[key](config); });
        }
        else {
            chart.guide()[key](other[key]);
        }
    });
    if (topUnit) {
        // 顶部单位
        var defaultUnitConfig = {
            top: true,
            position: ['-3%', '-10%'],
            style: {
                fill: '#8dabc4',
            },
            content: '单位',
            offsetX: 0,
            offsetY: 0,
        };
        if (Array.isArray(topUnit)) {
            var firstText = topUnit[0], secondText = topUnit[1];
            chart
                .guide()
                .text(Object.assign(defaultUnitConfig, { content: firstText, position: ['-3%', '-10%'] }));
            chart
                .guide()
                .text(Object.assign(defaultUnitConfig, { content: secondText, position: ['97%', '-10%'] }));
        }
        else {
            chart.guide().text(Object.assign(defaultUnitConfig, { content: topUnit }));
        }
    }
}

function legend (chart, config, legendConfig, yField) {
    var finalYField = yField || true;
    var finalLegendConfig = legendConfig;
    if (Array.isArray(legendConfig)) {
        finalYField = legendConfig[0];
        finalLegendConfig = legendConfig[1];
    }
    if (finalLegendConfig === false || get$1(finalLegendConfig, 'visible') === false) {
        if (Array.isArray(legendConfig)) {
            chart.legend(finalYField, false);
        }
        else {
            chart.legend(false);
        }
        return;
    }
    if (get$1(finalLegendConfig, 'tip')) {
        var dom_1 = get$1(chart, '_attrs.canvas._cfg.canvasDOM');
        dom_1.title = null;
        var onHover = function (event) {
            var value = get$1(event, 'item.value');
            var text = value;
            if (get$1(config, 'legend.tipFormatter') && isFunction$1(config.legend.tipFormatter)) {
                text = config.legend.tipFormatter(get$1(event, 'item.value'));
            }
            else if (get$1(config, 'legend.itemFormatter') && isFunction$1(config.legend.itemFormatter)) {
                text = config.legend.itemFormatter(get$1(event, 'item.value'));
            }
            dom_1.title = text;
        };
        if (Array.isArray(legendConfig)) {
            chart.legend(finalYField, { onHover: onHover });
        }
        else {
            chart.legend({ onHover: onHover });
        }
    }
    finalLegendConfig = Object.assign({}, { position: 'bottom-center' }, finalLegendConfig);
    chart.legend(yField, finalLegendConfig);
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

var _arraySome = arraySome;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new _SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!_arraySome(other, function(othValue, othIndex) {
            if (!_cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    errorTag$1 = '[object Error]',
    mapTag$3 = '[object Map]',
    numberTag$2 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$3 = '[object Set]',
    stringTag$2 = '[object String]',
    symbolTag$1 = '[object Symbol]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$2 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$2:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag$1:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new _Uint8Array(object), new _Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag$1:
    case dateTag$1:
    case numberTag$2:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq_1(+object, +other);

    case errorTag$1:
      return object.name == other.name && object.message == other.message;

    case regexpTag$1:
    case stringTag$2:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag$3:
      var convert = _mapToArray;

    case setTag$3:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1;
      convert || (convert = _setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$1;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = _equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag$1:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

var _equalByTag = equalByTag;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

var stubArray_1 = stubArray;

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$d.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray_1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable$1.call(object, symbol);
  });
};

var _getSymbols = getSymbols;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

var keys_1 = keys;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return _baseGetAllKeys(object, keys_1, _getSymbols);
}

var _getAllKeys = getAllKeys;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** Used for built-in method references. */
var objectProto$e = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$e.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2,
      objProps = _getAllKeys(object),
      objLength = objProps.length,
      othProps = _getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$b.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    objectTag$3 = '[object Object]';

/** Used for built-in method references. */
var objectProto$f = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$f.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray_1(object),
      othIsArr = isArray_1(other),
      objTag = objIsArr ? arrayTag$1 : _getTag(object),
      othTag = othIsArr ? arrayTag$1 : _getTag(other);

  objTag = objTag == argsTag$2 ? objectTag$3 : objTag;
  othTag = othTag == argsTag$2 ? objectTag$3 : othTag;

  var objIsObj = objTag == objectTag$3,
      othIsObj = othTag == objectTag$3,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer_1(object)) {
    if (!isBuffer_1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new _Stack);
    return (objIsArr || isTypedArray_1(object))
      ? _equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : _equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$3)) {
    var objIsWrapped = objIsObj && hasOwnProperty$c.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$c.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new _Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new _Stack);
  return _equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike_1(value) && !isObjectLike_1(other))) {
    return value !== value && other !== other;
  }
  return _baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

var _baseIsEqual = baseIsEqual;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return _baseIsEqual(value, other);
}

var isEqual_1 = isEqual;

/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */
function isEqualWith(value, other, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  var result = customizer ? customizer(value, other) : undefined;
  return result === undefined ? _baseIsEqual(value, other, undefined, customizer) : !!result;
}

var isEqualWith_1 = isEqualWith;

var Updater = {
    needRebuildChart: function (unifiedProps, nextUnifiedProps) {
        if (unifiedProps == null || nextUnifiedProps == null)
            return false;
        if (!shallowEqual(unifiedProps.padding, nextUnifiedProps.padding) ||
            !shallowEqual(unifiedProps.background, nextUnifiedProps.background) ||
            !shallowEqual(unifiedProps.plotBackground, nextUnifiedProps.plotBackground) ||
            !shallowEqual(unifiedProps.pixelRatio, nextUnifiedProps.pixelRatio)) {
            return true;
        }
        return false;
    },
};

// import { G2 } from 'bizcharts';
//
// const dataVTheme = G2.Util.deepMix({
//   defaultColor: 'black',
// }, G2.Theme);
//
// G2.Global.setTheme('dataVTheme');
var _a;
var DEFAULT_COLOR = '#2196F3';
var COLOR_PLATE_8 = [
    '#2196F3',
    '#2FC25B',
    '#FACC14',
    '#223273',
    '#8543E0',
    '#13C2C2',
    '#3436C7',
    '#F04864',
];
var COLOR_PLATE_16 = [
    '#2196F3',
    '#2FC25B',
    '#FACC14',
    '#41D9C7',
    '#E6965C',
    '#223273',
    '#7564CC',
    '#8543E0',
    '#5C8EE6',
    '#13C2C2',
    '#5CA3E6',
    '#3436C7',
    '#B381E6',
    '#F04864',
    '#D598D9',
];
var COLOR_PLATE_24 = [
    '#2196F3',
    '#2FC25B',
    '#13C2C2',
    '#66B5FF',
    '#41D9C7',
    '#6EDB8F',
    '#9AE65C',
    '#FACC14',
    '#E6965C',
    '#57AD71',
    '#F44336',
    '#738AE6',
    '#7564CC',
    '#8543E0',
    '#A877ED',
    '#5C8EE6',
    '#70E0E0',
    '#5CA3E6',
    '#3436C7',
    '#8082FF',
    '#DD81E6',
    '#F04864',
    '#FA7D92',
    '#D598D9',
];
var COLOR_PIE = [
    '#2196F3',
    '#13C2C2',
    '#2FC25B',
    '#FACC14',
    '#F04864',
    '#8543E0',
    '#3436C7',
    '#223273',
];
var COLOR_PIE_16 = [
    '#2196F3',
    '#73C9E6',
    '#13C2C2',
    '#6CD9B3',
    '#2FC25B',
    '#9DD96C',
    '#FACC14',
    '#E6965C',
    '#F04864',
    '#D66BCA',
    '#8543E0',
    '#8E77ED',
    '#3436C7',
    '#737EE6',
    '#223273',
    '#7EA2E6',
];
var FONT_FAMILY = 'Roboto, PingFangSC-Light';
// tooltip's dom element classname
var TOOLTIP_CONTAINER_CLASS = 'g2-tooltip';
var TOOLTIP_TITLE_CLASS = 'g2-tooltip-title';
var TOOLTIP_LIST_CLASS = 'g2-tooltip-list';
var TOOLTIP_LIST_ITEM_CLASS = 'g2-tooltip-list-item';
var TOOLTIP_MARKER_CLASS = 'g2-tooltip-marker';
var normalTheme = {
    background: {
        fill: '#ffffff',
    },
    defaultColor: DEFAULT_COLOR,
    plotCfg: {
        padding: [20, 20, 95, 80],
    },
    fontFamily: FONT_FAMILY,
    defaultLegendPosition: 'bottom',
    colors: COLOR_PLATE_8,
    colors_16: COLOR_PLATE_16,
    colors_24: COLOR_PLATE_24,
    colors_pie: COLOR_PIE,
    colors_pie_16: COLOR_PIE_16,
    shapes: {
        point: [
            'hollowCircle',
            'hollowSquare',
            'hollowDiamond',
            'hollowBowtie',
            'hollowTriangle',
            'hollowHexagon',
            'cross',
            'tick',
            'plus',
            'hyphen',
            'line',
        ],
        line: ['line', 'dash', 'dot'],
        area: ['area'],
    },
    markerRadius: 4,
    sizes: [1, 10],
    opacities: [0.1, 0.9],
    axis: {
        top: {
            position: 'top',
            title: null,
            label: {
                offset: 14,
                textStyle: {
                    fill: '#3f536e',
                    fontSize: 12,
                    lineHeight: 20,
                    textBaseline: 'middle',
                },
                autoRotate: true,
            },
            line: { stroke: '#c4d9e9', lineWidth: 1 },
            tickLine: { stroke: '#c4d9e9', lineWidth: 1, length: 3 },
        },
        bottom: {
            position: 'bottom',
            title: null,
            label: {
                offset: 15,
                autoRotate: true,
                textStyle: {
                    fill: '#3f536e',
                    fontSize: 12,
                    lineHeight: 20,
                    textBaseline: 'middle',
                },
            },
            line: { stroke: '#c4d9e9', lineWidth: 1 },
            tickLine: { stroke: '#c4d9e9', lineWidth: 1, length: 3 },
        },
        left: {
            position: 'left',
            title: null,
            label: {
                offset: 12,
                autoRotate: true,
                textStyle: {
                    fill: '#3f536e',
                    fontSize: 12,
                    lineHeight: 20,
                    textBaseline: 'middle',
                },
            },
            line: null,
            tickLine: null,
            grid: {
                lineStyle: {
                    stroke: '#c4d9e9',
                    lineWidth: 1,
                    lineDash: [4, 4],
                },
                hideFirstLine: true,
            },
        },
        right: {
            position: 'right',
            title: null,
            label: {
                offset: 12,
                autoRotate: true,
                textStyle: {
                    fill: '#3f536e',
                    fontSize: 12,
                    lineHeight: 20,
                    textBaseline: 'middle',
                },
            },
            line: null,
            tickLine: null,
            grid: {
                lineStyle: {
                    stroke: '#c4d9e9',
                    lineWidth: 1,
                    lineDash: [4, 4],
                },
                hideFirstLine: true,
            },
        },
        circle: {
            zIndex: 1,
            title: null,
            label: {
                offset: 12,
                textStyle: {
                    fill: '#3f536e',
                    fontSize: 12,
                    lineHeight: 20,
                },
            },
            line: {
                lineWidth: 1,
                stroke: '#c4d9e9',
            },
            tickLine: {
                lineWidth: 1,
                stroke: '#c4d9e9',
                length: 3,
            },
            grid: {
                lineStyle: {
                    stroke: '#c4d9e9',
                    lineWidth: 1,
                    lineDash: [4, 4],
                },
                hideFirstLine: true,
            },
        },
        radius: {
            zIndex: 0,
            label: {
                offset: 12,
                textStyle: {
                    fill: '#3f536e',
                    fontSize: 12,
                    textBaseline: 'middle',
                    lineHeight: 20,
                },
            },
            line: {
                lineWidth: 1,
                stroke: '#c4d9e9',
            },
            tickLine: {
                lineWidth: 1,
                stroke: '#c4d9e9',
                length: 3,
            },
            grid: {
                lineStyle: {
                    stroke: '#c4d9e9',
                    lineWidth: 1,
                    lineDash: [4, 4],
                },
                type: 'circle',
            },
        },
        helix: {
            grid: null,
            label: null,
            title: null,
            line: {
                lineWidth: 1,
                stroke: '#c4d9e9',
            },
            tickLine: {
                lineWidth: 1,
                length: 3,
                stroke: '#c4d9e9',
            },
        },
    },
    label: {
        offset: 20,
        textStyle: {
            fill: '#3f536e',
            fontSize: 12,
            textBaseline: 'middle',
        },
    },
    treemapLabels: {
        offset: 10,
        textStyle: {
            fill: '#fff',
            fontSize: 12,
            textBaseline: 'top',
            fontStyle: 'bold',
        },
    },
    innerLabels: {
        textStyle: {
            fill: '#fff',
            fontSize: 12,
            textBaseline: 'middle',
        },
    },
    // 在theta坐标系下的饼图文本内部的样式
    thetaLabels: {
        labelLine: {
            lineWidth: 1,
        },
        labelHeight: 14,
        offset: 30,
    },
    legend: {
        right: {
            position: 'right',
            layout: 'vertical',
            itemMarginBottom: 8,
            width: 16,
            height: 156,
            title: null,
            textStyle: {
                fill: '#3f536e',
                fontSize: 12,
                textAlign: 'start',
                textBaseline: 'middle',
                lineHeight: 20,
            },
            unCheckColor: '#c4d9e9',
        },
        left: {
            position: 'left',
            layout: 'vertical',
            itemMarginBottom: 8,
            width: 16,
            height: 156,
            title: null,
            textStyle: {
                fill: '#3f536e',
                fontSize: 12,
                textAlign: 'start',
                textBaseline: 'middle',
                lineHeight: 20,
            },
            unCheckColor: '#c4d9e9',
        },
        top: {
            position: 'top',
            offset: 6,
            layout: 'horizontal',
            title: null,
            itemGap: 10,
            width: 156,
            height: 16,
            textStyle: {
                fill: '#3f536e',
                fontSize: 12,
                textAlign: 'start',
                textBaseline: 'middle',
                lineHeight: 20,
            },
            unCheckColor: '#c4d9e9',
        },
        bottom: {
            position: 'bottom',
            offset: 58,
            layout: 'horizontal',
            title: null,
            itemGap: 24,
            width: 156,
            height: 16,
            textStyle: {
                fill: '#3f536e',
                fontSize: 12,
                textAlign: 'start',
                textBaseline: 'middle',
                lineHeight: 20,
            },
            unCheckColor: '#c4d9e9',
        },
        html: {
            'g2-legend': {
                height: 'auto',
                width: 'auto',
                position: 'absolute',
                overflow: 'auto',
                fontSize: '12px',
                fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
                lineHeight: '20px',
                color: '#8C8C8C',
            },
            'g2-legend-title': {
                marginBottom: '4px',
            },
            'g2-legend-list': {
                listStyleType: 'none',
                margin: 0,
                padding: 0,
            },
            'g2-legend-list-item': {
                cursor: 'pointer',
                marginBottom: '5px',
                marginRight: '24px',
            },
            'g2-legend-marker': {
                width: '9px',
                height: '9px',
                borderRadius: '50%',
                display: 'inline-block',
                marginRight: '8px',
                verticalAlign: 'middle',
            },
        },
    },
    tooltip: (_a = {
            useHtml: true,
            crosshairs: false,
            offset: 24
        },
        // css style for tooltip
        _a["" + TOOLTIP_CONTAINER_CLASS] = {
            position: 'absolute',
            visibility: 'hidden',
            zIndex: 999,
            transition: 'visibility 0.2s cubic-bezier(0.23, 1, 0.32, 1), left 0.4s cubic-bezier(0.23, 1, 0.32, 1), top 0.4s cubic-bezier(0.23, 1, 0.32, 1)',
            backgroundColor: 'white',
            boxShadow: '0 0 4px rgba(0, 0, 0, 0.15)',
            borderRadius: 'none',
            color: '#777f84',
            fontSize: '12px',
            fontFamily: FONT_FAMILY,
            lineHeight: '20px',
            padding: '12px 15px',
        },
        _a["" + TOOLTIP_TITLE_CLASS] = {
            marginBottom: '10px',
            color: '#3f536e',
        },
        _a["" + TOOLTIP_LIST_CLASS] = {
            marginTop: '6px',
            listStyleType: 'none',
            padding: 0,
        },
        _a["" + TOOLTIP_LIST_ITEM_CLASS] = {
            marginBottom: '4px',
            color: '#3f536e',
        },
        _a["" + TOOLTIP_MARKER_CLASS] = {
            width: '10px',
            height: '10px',
            borderRadius: '50%',
            border: '1px solid #fff',
            display: 'inline-block',
            marginRight: '8px',
        },
        _a),
    tooltipCrosshairsRect: {
        type: 'rect',
        style: {
            fill: '#CCD6EC',
            opacity: 0.3,
        },
    },
    tooltipCrosshairsLine: {
        style: {
            stroke: 'rgba(0, 0, 0, 0.25)',
            lineWidth: 1,
        },
    },
    shape: {
        point: {
            lineWidth: 1,
            fill: DEFAULT_COLOR,
            radius: 4,
        },
        hollowPoint: {
            fill: '#fff',
            lineWidth: 1,
            stroke: DEFAULT_COLOR,
            radius: 3,
        },
        interval: {
            lineWidth: 0,
            fill: DEFAULT_COLOR,
        },
        pie: {
            lineWidth: 1,
            stroke: '#fff',
        },
        hollowInterval: {
            fill: '#fff',
            stroke: DEFAULT_COLOR,
            fillOpacity: 0,
            lineWidth: 1,
        },
        area: {
            lineWidth: 0,
            fill: DEFAULT_COLOR,
            fillOpacity: 0.3,
        },
        polygon: {
            lineWidth: 0,
            fill: DEFAULT_COLOR,
            fillOpacity: 1,
        },
        hollowPolygon: {
            fill: '#fff',
            stroke: DEFAULT_COLOR,
            fillOpacity: 0,
            lineWidth: 1,
        },
        hollowArea: {
            fill: '#fff',
            stroke: DEFAULT_COLOR,
            fillOpacity: 0,
            lineWidth: 1,
        },
        line: {
            stroke: DEFAULT_COLOR,
            lineWidth: 2,
            fill: null,
        },
    },
    guide: {
        line: {
            lineStyle: {
                stroke: DEFAULT_COLOR,
                lineDash: [0, 2, 2],
                lineWidth: 1,
            },
            text: {
                position: 'end',
                autoRotate: true,
                style: {
                    fill: '#3f536e',
                    fontSize: 12,
                    textAlign: 'center',
                },
            },
        },
        text: {
            style: {
                fill: '#3f536e',
                fontSize: 12,
                textBaseline: 'middle',
                textAlign: 'start',
            },
        },
        region: {
            style: {
                lineWidth: 0,
                fill: '#000',
                fillOpacity: 0.04,
            },
        },
        html: {
            alignX: 'middle',
            alignY: 'middle',
        },
    },
    pixelRatio: null,
};

// import { G2 } from 'bizcharts';
//
// const dataVTheme = G2.Util.deepMix({
//   defaultColor: 'black',
// }, G2.Theme);
//
// G2.Global.setTheme('dataVTheme');
var _a$1;
var DEFAULT_COLOR$1 = '#2196F3';
var COLOR_PLATE_8$1 = [
    '#2196F3',
    '#2FC25B',
    '#2FC25B',
    '#223273',
    '#8543E0',
    '#13C2C2',
    '#3436C7',
    '#F04864',
];
var COLOR_PLATE_16$1 = [
    '#2196F3',
    '#2FC25B',
    '#FACC14',
    '#41D9C7',
    '#E6965C',
    '#223273',
    '#7564CC',
    '#8543E0',
    '#5C8EE6',
    '#13C2C2',
    '#5CA3E6',
    '#3436C7',
    '#B381E6',
    '#F04864',
    '#D598D9',
];
var COLOR_PLATE_24$1 = [
    '#2196F3',
    '#2FC25B',
    '#13C2C2',
    '#66B5FF',
    '#41D9C7',
    '#6EDB8F',
    '#9AE65C',
    '#FACC14',
    '#E6965C',
    '#57AD71',
    '#F44336',
    '#738AE6',
    '#7564CC',
    '#8543E0',
    '#A877ED',
    '#5C8EE6',
    '#70E0E0',
    '#5CA3E6',
    '#3436C7',
    '#8082FF',
    '#DD81E6',
    '#F04864',
    '#FA7D92',
    '#D598D9',
];
var COLOR_PIE$1 = [
    '#2196F3',
    '#13C2C2',
    '#2FC25B',
    '#FACC14',
    '#F04864',
    '#8543E0',
    '#3436C7',
    '#223273',
];
var COLOR_PIE_16$1 = [
    '#2196F3',
    '#73C9E6',
    '#13C2C2',
    '#6CD9B3',
    '#2FC25B',
    '#9DD96C',
    '#FACC14',
    '#E6965C',
    '#F04864',
    '#D66BCA',
    '#8543E0',
    '#8E77ED',
    '#3436C7',
    '#737EE6',
    '#223273',
    '#7EA2E6',
];
var FONT_FAMILY$1 = 'Roboto, PingFangSC-Light';
// tooltip's dom element classname
var TOOLTIP_CONTAINER_CLASS$1 = 'g2-tooltip';
var TOOLTIP_TITLE_CLASS$1 = 'g2-tooltip-title';
var TOOLTIP_LIST_CLASS$1 = 'g2-tooltip-list';
var TOOLTIP_LIST_ITEM_CLASS$1 = 'g2-tooltip-list-item';
var TOOLTIP_MARKER_CLASS$1 = 'g2-tooltip-marker';
var yunzhiTheme = {
    background: {
        fill: '#ffffff',
    },
    defaultColor: DEFAULT_COLOR$1,
    plotCfg: {
        padding: [20, 20, 95, 80],
    },
    fontFamily: FONT_FAMILY$1,
    defaultLegendPosition: 'bottom',
    colors: COLOR_PLATE_8$1,
    colors_16: COLOR_PLATE_16$1,
    colors_24: COLOR_PLATE_24$1,
    colors_pie: COLOR_PIE$1,
    colors_pie_16: COLOR_PIE_16$1,
    shapes: {
        point: [
            'hollowCircle',
            'hollowSquare',
            'hollowDiamond',
            'hollowBowtie',
            'hollowTriangle',
            'hollowHexagon',
            'cross',
            'tick',
            'plus',
            'hyphen',
            'line',
        ],
        line: ['line', 'dash', 'dot'],
        area: ['area'],
    },
    markerRadius: 4,
    sizes: [1, 10],
    opacities: [0.1, 0.9],
    axis: {
        top: {
            position: 'top',
            title: null,
            label: {
                offset: 14,
                textStyle: {
                    fill: '#3f536e',
                    fontSize: 12,
                    lineHeight: 20,
                    textBaseline: 'middle',
                },
                autoRotate: true,
            },
            line: { stroke: '#c4d9e9', lineWidth: 1 },
            tickLine: { stroke: '#c4d9e9', lineWidth: 1, length: 3 },
        },
        bottom: {
            position: 'bottom',
            title: null,
            label: {
                offset: 15,
                autoRotate: true,
                textStyle: {
                    fill: '#3f536e',
                    fontSize: 12,
                    lineHeight: 20,
                    textBaseline: 'middle',
                },
            },
            line: { stroke: '#c4d9e9', lineWidth: 1 },
            tickLine: { stroke: '#c4d9e9', lineWidth: 1, length: 3 },
        },
        left: {
            position: 'left',
            title: null,
            label: {
                offset: 12,
                autoRotate: true,
                textStyle: {
                    fill: '#3f536e',
                    fontSize: 12,
                    lineHeight: 20,
                    textBaseline: 'middle',
                },
            },
            line: null,
            tickLine: null,
            grid: {
                lineStyle: {
                    stroke: '#c4d9e9',
                    lineWidth: 1,
                    lineDash: [4, 4],
                },
                hideFirstLine: true,
            },
        },
        right: {
            position: 'right',
            title: null,
            label: {
                offset: 12,
                autoRotate: true,
                textStyle: {
                    fill: '#3f536e',
                    fontSize: 12,
                    lineHeight: 20,
                    textBaseline: 'middle',
                },
            },
            line: null,
            tickLine: null,
            grid: {
                lineStyle: {
                    stroke: '#c4d9e9',
                    lineWidth: 1,
                    lineDash: [4, 4],
                },
                hideFirstLine: true,
            },
        },
        circle: {
            zIndex: 1,
            title: null,
            label: {
                offset: 12,
                textStyle: {
                    fill: '#3f536e',
                    fontSize: 12,
                    lineHeight: 20,
                },
            },
            line: {
                lineWidth: 1,
                stroke: '#c4d9e9',
            },
            tickLine: {
                lineWidth: 1,
                stroke: '#c4d9e9',
                length: 3,
            },
            grid: {
                lineStyle: {
                    stroke: '#c4d9e9',
                    lineWidth: 1,
                    lineDash: [4, 4],
                },
                hideFirstLine: true,
            },
        },
        radius: {
            zIndex: 0,
            label: {
                offset: 12,
                textStyle: {
                    fill: '#3f536e',
                    fontSize: 12,
                    textBaseline: 'middle',
                    lineHeight: 20,
                },
            },
            line: {
                lineWidth: 1,
                stroke: '#c4d9e9',
            },
            tickLine: {
                lineWidth: 1,
                stroke: '#c4d9e9',
                length: 3,
            },
            grid: {
                lineStyle: {
                    stroke: '#c4d9e9',
                    lineWidth: 1,
                    lineDash: [4, 4],
                },
                type: 'circle',
            },
        },
        helix: {
            grid: null,
            label: null,
            title: null,
            line: {
                lineWidth: 1,
                stroke: '#c4d9e9',
            },
            tickLine: {
                lineWidth: 1,
                length: 3,
                stroke: '#c4d9e9',
            },
        },
    },
    label: {
        offset: 20,
        textStyle: {
            fill: '#3f536e',
            fontSize: 12,
            textBaseline: 'middle',
        },
    },
    treemapLabels: {
        offset: 10,
        textStyle: {
            fill: '#fff',
            fontSize: 12,
            textBaseline: 'top',
            fontStyle: 'bold',
        },
    },
    innerLabels: {
        textStyle: {
            fill: '#fff',
            fontSize: 12,
            textBaseline: 'middle',
        },
    },
    // 在theta坐标系下的饼图文本内部的样式
    thetaLabels: {
        labelLine: {
            lineWidth: 1,
        },
        labelHeight: 14,
        offset: 30,
    },
    legend: {
        right: {
            position: 'right',
            layout: 'vertical',
            itemMarginBottom: 8,
            width: 16,
            height: 156,
            title: null,
            textStyle: {
                fill: '#3f536e',
                fontSize: 12,
                textAlign: 'start',
                textBaseline: 'middle',
                lineHeight: 20,
            },
            unCheckColor: '#c4d9e9',
        },
        left: {
            position: 'left',
            layout: 'vertical',
            itemMarginBottom: 8,
            width: 16,
            height: 156,
            title: null,
            textStyle: {
                fill: '#3f536e',
                fontSize: 12,
                textAlign: 'start',
                textBaseline: 'middle',
                lineHeight: 20,
            },
            unCheckColor: '#c4d9e9',
        },
        top: {
            position: 'top',
            offset: 6,
            layout: 'horizontal',
            title: null,
            itemGap: 10,
            width: 156,
            height: 16,
            textStyle: {
                fill: '#3f536e',
                fontSize: 12,
                textAlign: 'start',
                textBaseline: 'middle',
                lineHeight: 20,
            },
            unCheckColor: '#c4d9e9',
        },
        bottom: {
            position: 'bottom',
            offset: 58,
            layout: 'horizontal',
            title: null,
            itemGap: 24,
            width: 156,
            height: 16,
            textStyle: {
                fill: '#3f536e',
                fontSize: 12,
                textAlign: 'start',
                textBaseline: 'middle',
                lineHeight: 20,
            },
            unCheckColor: '#c4d9e9',
        },
        html: {
            'g2-legend': {
                height: 'auto',
                width: 'auto',
                position: 'absolute',
                overflow: 'auto',
                fontSize: '12px',
                fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
                lineHeight: '20px',
                color: '#8C8C8C',
            },
            'g2-legend-title': {
                marginBottom: '4px',
            },
            'g2-legend-list': {
                listStyleType: 'none',
                margin: 0,
                padding: 0,
            },
            'g2-legend-list-item': {
                cursor: 'pointer',
                marginBottom: '5px',
                marginRight: '24px',
            },
            'g2-legend-marker': {
                width: '9px',
                height: '9px',
                borderRadius: '50%',
                display: 'inline-block',
                marginRight: '8px',
                verticalAlign: 'middle',
            },
        },
    },
    tooltip: (_a$1 = {
            useHtml: true,
            crosshairs: false,
            offset: 24
        },
        // css style for tooltip
        _a$1["" + TOOLTIP_CONTAINER_CLASS$1] = {
            position: 'absolute',
            visibility: 'hidden',
            zIndex: 999,
            transition: 'visibility 0.2s cubic-bezier(0.23, 1, 0.32, 1), left 0.4s cubic-bezier(0.23, 1, 0.32, 1), top 0.4s cubic-bezier(0.23, 1, 0.32, 1)',
            backgroundColor: 'white',
            boxShadow: '0 0 4px rgba(0, 0, 0, 0.15)',
            borderRadius: 'none',
            color: '#777f84',
            fontSize: '12px',
            fontFamily: FONT_FAMILY$1,
            lineHeight: '20px',
            padding: '12px 15px',
            textAlign: 'left',
        },
        _a$1["" + TOOLTIP_TITLE_CLASS$1] = {
            marginBottom: '10px',
            color: '#3f536e',
        },
        _a$1["" + TOOLTIP_LIST_CLASS$1] = {
            marginTop: '6px',
            listStyleType: 'none',
            padding: 0,
        },
        _a$1["" + TOOLTIP_LIST_ITEM_CLASS$1] = {
            marginBottom: '4px',
            color: '#3f536e',
        },
        _a$1["" + TOOLTIP_MARKER_CLASS$1] = {
            width: '10px',
            height: '10px',
            borderRadius: '50%',
            border: '1px solid #fff',
            display: 'inline-block',
            marginRight: '8px',
        },
        _a$1),
    tooltipCrosshairsRect: {
        type: 'rect',
        style: {
            fill: '#CCD6EC',
            opacity: 0.3,
        },
    },
    tooltipCrosshairsLine: {
        style: {
            stroke: 'rgba(0, 0, 0, 0.25)',
            lineWidth: 1,
        },
    },
    shape: {
        point: {
            lineWidth: 1,
            fill: DEFAULT_COLOR$1,
            radius: 4,
        },
        hollowPoint: {
            fill: '#fff',
            lineWidth: 1,
            stroke: DEFAULT_COLOR$1,
            radius: 3,
        },
        interval: {
            lineWidth: 0,
            fill: DEFAULT_COLOR$1,
        },
        pie: {
            lineWidth: 1,
            stroke: '#fff',
        },
        hollowInterval: {
            fill: '#fff',
            stroke: DEFAULT_COLOR$1,
            fillOpacity: 0,
            lineWidth: 1,
        },
        area: {
            lineWidth: 0,
            fill: DEFAULT_COLOR$1,
            fillOpacity: 0.3,
        },
        polygon: {
            lineWidth: 0,
            fill: DEFAULT_COLOR$1,
            fillOpacity: 1,
        },
        hollowPolygon: {
            fill: '#fff',
            stroke: DEFAULT_COLOR$1,
            fillOpacity: 0,
            lineWidth: 1,
        },
        hollowArea: {
            fill: '#fff',
            stroke: DEFAULT_COLOR$1,
            fillOpacity: 0,
            lineWidth: 1,
        },
        line: {
            stroke: DEFAULT_COLOR$1,
            lineWidth: 2,
            fill: null,
        },
    },
    guide: {
        line: {
            lineStyle: {
                stroke: DEFAULT_COLOR$1,
                lineDash: [0, 2, 2],
                lineWidth: 1,
            },
            text: {
                position: 'end',
                autoRotate: true,
                style: {
                    fill: '#3f536e',
                    fontSize: 12,
                    textAlign: 'center',
                },
            },
        },
        text: {
            style: {
                fill: '#3f536e',
                fontSize: 12,
                textBaseline: 'middle',
                textAlign: 'start',
            },
        },
        region: {
            style: {
                lineWidth: 0,
                fill: '#000',
                fillOpacity: 0.04,
            },
        },
        html: {
            alignX: 'middle',
            alignY: 'middle',
        },
    },
    pixelRatio: null,
};

var darkTheme = {
    background: {
        fill: '#333333',
    },
    defaultColor: '#dd6b66',
    plotCfg: {
        padding: [20, 20, 95, 80],
    },
    fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
    defaultLegendPosition: 'bottom',
    colors: ['#dd6b66', '#759aa0', '#e69d87', '#8dc1a9', '#ea7e53', '#eedd78', '#73a373', '#73b9bc'],
    colors_16: [
        '#dd6b66',
        '#759aa0',
        '#e69d87',
        '#8dc1a9',
        '#ea7e53',
        '#eedd78',
        '#73a373',
        '#73b9bc',
        '#7289ab',
        '#91ca8c',
        '#f49f42',
        '#dd6b66',
        '#759aa0',
        '#e69d87',
        '#8dc1a9',
        '#ea7e53',
    ],
    colors_24: [
        '#dd6b66',
        '#759aa0',
        '#e69d87',
        '#8dc1a9',
        '#ea7e53',
        '#eedd78',
        '#73a373',
        '#73b9bc',
        '#7289ab',
        '#91ca8c',
        '#f49f42',
        '#dd6b66',
        '#759aa0',
        '#e69d87',
        '#8dc1a9',
        '#ea7e53',
        '#eedd78',
        '#73a373',
        '#73b9bc',
        '#7289ab',
        '#91ca8c',
        '#f49f42',
        '#dd6b66',
        '#759aa0',
    ],
    colors_pie: [
        '#dd6b66',
        '#759aa0',
        '#e69d87',
        '#8dc1a9',
        '#ea7e53',
        '#eedd78',
        '#73a373',
        '#73b9bc',
    ],
    colors_pie_16: [
        '#dd6b66',
        '#759aa0',
        '#e69d87',
        '#8dc1a9',
        '#ea7e53',
        '#eedd78',
        '#73a373',
        '#73b9bc',
        '#7289ab',
        '#91ca8c',
        '#f49f42',
        '#dd6b66',
        '#759aa0',
        '#e69d87',
        '#8dc1a9',
        '#ea7e53',
    ],
    shapes: {
        point: [
            'hollowCircle',
            'hollowSquare',
            'hollowDiamond',
            'hollowBowtie',
            'hollowTriangle',
            'hollowHexagon',
            'cross',
            'tick',
            'plus',
            'hyphen',
            'line',
        ],
        line: ['line', 'dash', 'dot'],
        area: ['area'],
    },
    sizes: [1, 10],
    opacities: [0.1, 0.9],
    axis: {
        top: {
            position: 'top',
            title: null,
            label: {
                offset: 14,
                textStyle: {
                    fill: '#545454',
                    fontSize: 12,
                    lineHeight: 20,
                    textBaseline: 'middle',
                    fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
                },
                autoRotate: true,
            },
            line: {
                lineWidth: 1,
                stroke: '#BFBFBF',
            },
            tickLine: {
                lineWidth: 1,
                stroke: '#BFBFBF',
                length: 4,
                alignWithLabel: true,
            },
            grid: {
                zIndex: -1,
                lineStyle: {
                    stroke: '#E9E9E9',
                    lineWidth: 1,
                },
                hideFirstLine: true,
            },
        },
        bottom: {
            position: 'bottom',
            title: null,
            label: {
                offset: 22,
                autoRotate: true,
                textStyle: {
                    fill: '#545454',
                    fontSize: 12,
                    lineHeight: 20,
                    textBaseline: 'middle',
                    fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
                },
            },
            line: {
                lineWidth: 1,
                stroke: '#BFBFBF',
            },
            tickLine: {
                lineWidth: 1,
                stroke: '#BFBFBF',
                length: 4,
                alignWithLabel: true,
            },
            grid: {
                zIndex: -1,
                lineStyle: {
                    stroke: '#E9E9E9',
                    lineWidth: 1,
                },
                hideFirstLine: true,
            },
        },
        left: {
            position: 'left',
            title: null,
            label: {
                offset: 12,
                autoRotate: true,
                textStyle: {
                    fill: '#545454',
                    fontSize: 12,
                    lineHeight: 20,
                    textBaseline: 'middle',
                    fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
                },
            },
            line: {
                lineWidth: 1,
                stroke: '#BFBFBF',
            },
            tickLine: {
                lineWidth: 1,
                stroke: '#BFBFBF',
                length: 4,
                alignWithLabel: true,
            },
            grid: {
                zIndex: -1,
                lineStyle: {
                    stroke: '#E9E9E9',
                    lineWidth: 1,
                },
                hideFirstLine: true,
            },
        },
        right: {
            position: 'right',
            title: null,
            label: {
                offset: 12,
                autoRotate: true,
                textStyle: {
                    fill: '#545454',
                    fontSize: 12,
                    lineHeight: 20,
                    textBaseline: 'middle',
                    fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
                },
            },
            line: {
                lineWidth: 1,
                stroke: '#BFBFBF',
            },
            tickLine: {
                lineWidth: 1,
                stroke: '#BFBFBF',
                length: 4,
                alignWithLabel: true,
            },
            grid: {
                lineStyle: {
                    stroke: '#E9E9E9',
                    lineWidth: 1,
                },
                hideFirstLine: true,
            },
        },
        circle: {
            zIndex: 1,
            title: null,
            label: {
                offset: 12,
                textStyle: {
                    fill: '#545454',
                    fontSize: 12,
                    lineHeight: 20,
                    fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
                },
            },
            line: {
                lineWidth: 1,
                stroke: '#BFBFBF',
            },
            tickLine: {
                lineWidth: 1,
                stroke: '#BFBFBF',
                length: 4,
                alignWithLabel: true,
            },
            grid: {
                lineStyle: {
                    stroke: '#E9E9E9',
                    lineWidth: 1,
                    lineDash: [3, 3],
                },
                hideFirstLine: true,
            },
        },
        radius: {
            zIndex: 0,
            label: {
                offset: 12,
                textStyle: {
                    fill: '#545454',
                    fontSize: 12,
                    textBaseline: 'middle',
                    lineHeight: 20,
                    fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
                },
            },
            line: {
                lineWidth: 1,
                stroke: '#BFBFBF',
            },
            tickLine: {
                lineWidth: 1,
                stroke: '#BFBFBF',
                length: 4,
                alignWithLabel: true,
            },
            grid: {
                lineStyle: {
                    stroke: '#E9E9E9',
                    lineWidth: 1,
                    lineDash: [3, 3],
                },
                type: 'circle',
            },
        },
        helix: {
            label: null,
            title: null,
            line: {
                lineWidth: 1,
                stroke: '#BFBFBF',
            },
            tickLine: {
                lineWidth: 1,
                length: 4,
                stroke: '#BFBFBF',
                alignWithLabel: true,
            },
            grid: {
                lineStyle: {
                    stroke: '#E9E9E9',
                    lineWidth: 1,
                },
                type: 'circle',
            },
        },
    },
    label: {
        offset: 20,
        textStyle: {
            fill: '#545454',
            fontSize: 12,
            textBaseline: 'middle',
            fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
        },
    },
    treemapLabels: {
        offset: 10,
        textStyle: {
            fill: '#fff',
            fontSize: 12,
            textBaseline: 'top',
            fontStyle: 'bold',
            fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
        },
    },
    innerLabels: {
        textStyle: {
            fill: '#fff',
            fontSize: 12,
            textBaseline: 'middle',
            fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
        },
    },
    thetaLabels: {
        labelLine: {
            lineWidth: 1,
        },
        labelHeight: 14,
        offset: 30,
    },
    legend: {
        right: {
            position: 'right',
            layout: 'vertical',
            itemMarginBottom: 8,
            width: 16,
            height: 156,
            title: null,
            textStyle: {
                fill: '#8C8C8C',
                fontSize: 12,
                textAlign: 'start',
                textBaseline: 'middle',
                lineHeight: 20,
                fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
            },
            unCheckColor: '#bfbfbf',
        },
        left: {
            position: 'left',
            layout: 'vertical',
            itemMarginBottom: 8,
            width: 16,
            height: 156,
            title: null,
            textStyle: {
                fill: '#8C8C8C',
                fontSize: 12,
                textAlign: 'start',
                textBaseline: 'middle',
                lineHeight: 20,
                fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
            },
            unCheckColor: '#bfbfbf',
        },
        top: {
            position: 'top',
            offset: 6,
            layout: 'horizontal',
            title: null,
            itemGap: 10,
            width: 156,
            height: 16,
            textStyle: {
                fill: '#8C8C8C',
                fontSize: 12,
                textAlign: 'start',
                textBaseline: 'middle',
                lineHeight: 20,
                fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
            },
            unCheckColor: '#bfbfbf',
        },
        bottom: {
            position: 'bottom',
            offset: 6,
            layout: 'horizontal',
            title: null,
            itemGap: 10,
            width: 156,
            height: 16,
            textStyle: {
                fill: '#8C8C8C',
                fontSize: 12,
                textAlign: 'start',
                textBaseline: 'middle',
                lineHeight: 20,
                fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
            },
            unCheckColor: '#bfbfbf',
        },
        html: {
            'g2-legend': {
                height: 'auto',
                width: 'auto',
                position: 'absolute',
                overflow: 'auto',
                fontSize: '12px',
                fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
                lineHeight: '20px',
                color: '#8C8C8C',
            },
            'g2-legend-title': {
                marginBottom: '4px',
            },
            'g2-legend-list': {
                listStyleType: 'none',
                margin: 0,
                padding: 0,
            },
            'g2-legend-list-item': {
                cursor: 'pointer',
                marginBottom: '5px',
                marginRight: '24px',
            },
            'g2-legend-marker': {
                width: '9px',
                height: '9px',
                borderRadius: '50%',
                display: 'inline-block',
                marginRight: '8px',
                verticalAlign: 'middle',
            },
        },
        gradient: {
            textStyle: {
                fill: '#8C8C8C',
                fontSize: 12,
                textAlign: 'center',
                textBaseline: 'middle',
                lineHeight: 20,
                fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
            },
            lineStyle: {
                lineWidth: 1,
                stroke: '#fff',
            },
            unCheckColor: '#bfbfbf',
        },
        margin: [0, 20, 24, 5],
        legendMargin: 24,
    },
    tooltip: {
        crosshairs: false,
        offset: 15,
        'g2-tooltip': {
            position: 'absolute',
            visibility: 'hidden',
            zIndex: 8,
            transition: 'visibility 0.2s cubic-bezier(0.23, 1, 0.32, 1), left 0.4s cubic-bezier(0.23, 1, 0.32, 1), top 0.4s cubic-bezier(0.23, 1, 0.32, 1)',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            boxShadow: '0px 0px 10px #aeaeae',
            borderRadius: '3px',
            color: 'rgb(87, 87, 87)',
            fontSize: '12px',
            fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
            lineHeight: '20px',
            padding: '10px 10px 6px 10px',
        },
        'g2-tooltip-title': {
            marginBottom: '4px',
        },
        'g2-tooltip-list': {
            margin: 0,
            listStyleType: 'none',
            padding: 0,
        },
        'g2-tooltip-list-item': {
            marginBottom: '4px',
        },
        'g2-tooltip-marker': {
            width: '5px',
            height: '5px',
            borderRadius: '50%',
            display: 'inline-block',
            marginRight: '8px',
        },
        'g2-tooltip-value': {
            display: 'inline-block',
            float: 'right',
            marginLeft: '30px',
        },
    },
    tooltipMarker: {
        stroke: '#fff',
        shadowBlur: 8,
        shadowOffsetX: 0,
        shadowOffSetY: 0,
        radius: 4,
    },
    tooltipCrosshairsRect: {
        type: 'rect',
        style: {
            fill: '#CCD6EC',
            opacity: 0.3,
        },
    },
    tooltipCrosshairsLine: {
        style: {
            stroke: 'rgba(0, 0, 0, 0.25)',
            lineWidth: 1,
        },
    },
    shape: {
        point: {
            lineWidth: 1,
            fill: '#1890FF',
            radius: 4,
        },
        hollowPoint: {
            fill: '#fff',
            lineWidth: 1,
            stroke: '#1890FF',
            radius: 3,
        },
        interval: {
            lineWidth: 0,
            fill: '#1890FF',
            fillOpacity: 0.85,
        },
        hollowInterval: {
            fill: '#fff',
            stroke: '#1890FF',
            fillOpacity: 0,
            lineWidth: 2,
        },
        area: {
            lineWidth: 0,
            fill: '#1890FF',
            fillOpacity: 0.3,
        },
        polygon: {
            lineWidth: 0,
            fill: '#1890FF',
            fillOpacity: 1,
        },
        hollowPolygon: {
            fill: '#fff',
            stroke: '#1890FF',
            fillOpacity: 0,
            lineWidth: 2,
        },
        hollowArea: {
            fill: '#fff',
            stroke: '#1890FF',
            fillOpacity: 0,
            lineWidth: 2,
        },
        line: {
            stroke: '#1890FF',
            lineWidth: 2,
            fill: null,
        },
        edge: {
            stroke: '#1890FF',
            lineWidth: 1,
            fill: null,
        },
        schema: {
            stroke: '#1890FF',
            lineWidth: 1,
            fill: null,
        },
    },
    guide: {
        line: {
            lineStyle: {
                stroke: '#1890FF',
                lineDash: [0, 2, 2],
                lineWidth: 1,
            },
            text: {
                position: 'end',
                autoRotate: true,
                style: {
                    fill: '#545454',
                    fontSize: 12,
                    textAlign: 'center',
                    fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
                },
            },
        },
        text: {
            style: {
                fill: '#545454',
                fontSize: 12,
                textBaseline: 'middle',
                textAlign: 'start',
                fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
            },
        },
        region: {
            style: {
                lineWidth: 0,
                fill: '#000',
                fillOpacity: 0.04,
            },
        },
        html: {
            alignX: 'middle',
            alignY: 'middle',
        },
    },
    pixelRatio: null,
};

var macaronsTheme = {
    background: {
        fill: '#ffffff',
    },
    defaultColor: '#2ec7c9',
    plotCfg: {
        padding: [20, 20, 95, 80],
    },
    fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
    defaultLegendPosition: 'bottom',
    colors: ['#2ec7c9', '#b6a2de', '#5ab1ef', '#ffb980', '#d87a80', '#8d98b3', '#e5cf0d', '#97b552'],
    colors_16: [
        '#2ec7c9',
        '#b6a2de',
        '#5ab1ef',
        '#ffb980',
        '#d87a80',
        '#8d98b3',
        '#e5cf0d',
        '#97b552',
        '#95706d',
        '#dc69aa',
        '#07a2a4',
        '#9a7fd1',
        '#588dd5',
        '#f5994e',
        '#c05050',
        '#59678c',
    ],
    colors_24: [
        '#2ec7c9',
        '#b6a2de',
        '#5ab1ef',
        '#ffb980',
        '#d87a80',
        '#8d98b3',
        '#e5cf0d',
        '#97b552',
        '#95706d',
        '#dc69aa',
        '#07a2a4',
        '#9a7fd1',
        '#588dd5',
        '#f5994e',
        '#c05050',
        '#59678c',
        '#c9ab00',
        '#7eb00a',
        '#6f5553',
        '#c14089',
        '#2ec7c9',
        '#b6a2de',
        '#5ab1ef',
        '#ffb980',
    ],
    colors_pie: [
        '#2ec7c9',
        '#b6a2de',
        '#5ab1ef',
        '#ffb980',
        '#d87a80',
        '#8d98b3',
        '#e5cf0d',
        '#97b552',
    ],
    colors_pie_16: [
        '#2ec7c9',
        '#b6a2de',
        '#5ab1ef',
        '#ffb980',
        '#d87a80',
        '#8d98b3',
        '#e5cf0d',
        '#97b552',
        '#95706d',
        '#dc69aa',
        '#07a2a4',
        '#9a7fd1',
        '#588dd5',
        '#f5994e',
        '#c05050',
        '#59678c',
    ],
    shapes: {
        point: [
            'hollowCircle',
            'hollowSquare',
            'hollowDiamond',
            'hollowBowtie',
            'hollowTriangle',
            'hollowHexagon',
            'cross',
            'tick',
            'plus',
            'hyphen',
            'line',
        ],
        line: ['line', 'dash', 'dot'],
        area: ['area'],
    },
    sizes: [1, 10],
    opacities: [0.1, 0.9],
    axis: {
        top: {
            position: 'top',
            title: null,
            label: {
                offset: 14,
                textStyle: {
                    fill: '#545454',
                    fontSize: 12,
                    lineHeight: 20,
                    textBaseline: 'middle',
                    fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
                },
                autoRotate: true,
            },
            line: {
                lineWidth: 1,
                stroke: '#BFBFBF',
            },
            tickLine: {
                lineWidth: 1,
                stroke: '#BFBFBF',
                length: 4,
                alignWithLabel: true,
            },
            grid: {
                zIndex: -1,
                lineStyle: {
                    stroke: '#E9E9E9',
                    lineWidth: 1,
                },
                hideFirstLine: true,
            },
        },
        bottom: {
            position: 'bottom',
            title: null,
            label: {
                offset: 22,
                autoRotate: true,
                textStyle: {
                    fill: '#545454',
                    fontSize: 12,
                    lineHeight: 20,
                    textBaseline: 'middle',
                    fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
                },
            },
            line: {
                lineWidth: 1,
                stroke: '#BFBFBF',
            },
            tickLine: {
                lineWidth: 1,
                stroke: '#BFBFBF',
                length: 4,
                alignWithLabel: true,
            },
            grid: {
                zIndex: -1,
                lineStyle: {
                    stroke: '#E9E9E9',
                    lineWidth: 1,
                },
                hideFirstLine: true,
            },
        },
        left: {
            position: 'left',
            title: null,
            label: {
                offset: 12,
                autoRotate: true,
                textStyle: {
                    fill: '#545454',
                    fontSize: 12,
                    lineHeight: 20,
                    textBaseline: 'middle',
                    fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
                },
            },
            line: {
                lineWidth: 1,
                stroke: '#BFBFBF',
            },
            tickLine: {
                lineWidth: 1,
                stroke: '#BFBFBF',
                length: 4,
                alignWithLabel: true,
            },
            grid: {
                zIndex: -1,
                lineStyle: {
                    stroke: '#E9E9E9',
                    lineWidth: 1,
                },
                hideFirstLine: true,
            },
        },
        right: {
            position: 'right',
            title: null,
            label: {
                offset: 12,
                autoRotate: true,
                textStyle: {
                    fill: '#545454',
                    fontSize: 12,
                    lineHeight: 20,
                    textBaseline: 'middle',
                    fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
                },
            },
            line: {
                lineWidth: 1,
                stroke: '#BFBFBF',
            },
            tickLine: {
                lineWidth: 1,
                stroke: '#BFBFBF',
                length: 4,
                alignWithLabel: true,
            },
            grid: {
                lineStyle: {
                    stroke: '#E9E9E9',
                    lineWidth: 1,
                },
                hideFirstLine: true,
            },
        },
        circle: {
            zIndex: 1,
            title: null,
            label: {
                offset: 12,
                textStyle: {
                    fill: '#545454',
                    fontSize: 12,
                    lineHeight: 20,
                    fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
                },
            },
            line: {
                lineWidth: 1,
                stroke: '#BFBFBF',
            },
            tickLine: {
                lineWidth: 1,
                stroke: '#BFBFBF',
                length: 4,
                alignWithLabel: true,
            },
            grid: {
                lineStyle: {
                    stroke: '#E9E9E9',
                    lineWidth: 1,
                    lineDash: [3, 3],
                },
                hideFirstLine: true,
            },
        },
        radius: {
            zIndex: 0,
            label: {
                offset: 12,
                textStyle: {
                    fill: '#545454',
                    fontSize: 12,
                    textBaseline: 'middle',
                    lineHeight: 20,
                    fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
                },
            },
            line: {
                lineWidth: 1,
                stroke: '#BFBFBF',
            },
            tickLine: {
                lineWidth: 1,
                stroke: '#BFBFBF',
                length: 4,
                alignWithLabel: true,
            },
            grid: {
                lineStyle: {
                    stroke: '#E9E9E9',
                    lineWidth: 1,
                    lineDash: [3, 3],
                },
                type: 'circle',
            },
        },
        helix: {
            label: null,
            title: null,
            line: {
                lineWidth: 1,
                stroke: '#BFBFBF',
            },
            tickLine: {
                lineWidth: 1,
                length: 4,
                stroke: '#BFBFBF',
                alignWithLabel: true,
            },
            grid: {
                lineStyle: {
                    stroke: '#E9E9E9',
                    lineWidth: 1,
                },
                type: 'circle',
            },
        },
    },
    label: {
        offset: 20,
        textStyle: {
            fill: '#545454',
            fontSize: 12,
            textBaseline: 'middle',
            fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
        },
    },
    treemapLabels: {
        offset: 10,
        textStyle: {
            fill: '#fff',
            fontSize: 12,
            textBaseline: 'top',
            fontStyle: 'bold',
            fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
        },
    },
    innerLabels: {
        textStyle: {
            fill: '#fff',
            fontSize: 12,
            textBaseline: 'middle',
            fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
        },
    },
    thetaLabels: {
        labelLine: {
            lineWidth: 1,
        },
        labelHeight: 14,
        offset: 30,
    },
    legend: {
        right: {
            position: 'right',
            layout: 'vertical',
            itemMarginBottom: 8,
            width: 16,
            height: 156,
            title: null,
            textStyle: {
                fill: '#8C8C8C',
                fontSize: 12,
                textAlign: 'start',
                textBaseline: 'middle',
                lineHeight: 20,
                fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
            },
            unCheckColor: '#bfbfbf',
        },
        left: {
            position: 'left',
            layout: 'vertical',
            itemMarginBottom: 8,
            width: 16,
            height: 156,
            title: null,
            textStyle: {
                fill: '#8C8C8C',
                fontSize: 12,
                textAlign: 'start',
                textBaseline: 'middle',
                lineHeight: 20,
                fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
            },
            unCheckColor: '#bfbfbf',
        },
        top: {
            position: 'top',
            offset: 6,
            layout: 'horizontal',
            title: null,
            itemGap: 10,
            width: 156,
            height: 16,
            textStyle: {
                fill: '#8C8C8C',
                fontSize: 12,
                textAlign: 'start',
                textBaseline: 'middle',
                lineHeight: 20,
                fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
            },
            unCheckColor: '#bfbfbf',
        },
        bottom: {
            position: 'bottom',
            offset: 6,
            layout: 'horizontal',
            title: null,
            itemGap: 10,
            width: 156,
            height: 16,
            textStyle: {
                fill: '#8C8C8C',
                fontSize: 12,
                textAlign: 'start',
                textBaseline: 'middle',
                lineHeight: 20,
                fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
            },
            unCheckColor: '#bfbfbf',
        },
        html: {
            'g2-legend': {
                height: 'auto',
                width: 'auto',
                position: 'absolute',
                overflow: 'auto',
                fontSize: '12px',
                fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
                lineHeight: '20px',
                color: '#8C8C8C',
            },
            'g2-legend-title': {
                marginBottom: '4px',
            },
            'g2-legend-list': {
                listStyleType: 'none',
                margin: 0,
                padding: 0,
            },
            'g2-legend-list-item': {
                cursor: 'pointer',
                marginBottom: '5px',
                marginRight: '24px',
            },
            'g2-legend-marker': {
                width: '9px',
                height: '9px',
                borderRadius: '50%',
                display: 'inline-block',
                marginRight: '8px',
                verticalAlign: 'middle',
            },
        },
        gradient: {
            textStyle: {
                fill: '#8C8C8C',
                fontSize: 12,
                textAlign: 'center',
                textBaseline: 'middle',
                lineHeight: 20,
                fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
            },
            lineStyle: {
                lineWidth: 1,
                stroke: '#fff',
            },
            unCheckColor: '#bfbfbf',
        },
        margin: [0, 20, 24, 5],
        legendMargin: 24,
    },
    tooltip: {
        crosshairs: false,
        offset: 15,
        'g2-tooltip': {
            position: 'absolute',
            visibility: 'hidden',
            zIndex: 8,
            transition: 'visibility 0.2s cubic-bezier(0.23, 1, 0.32, 1), left 0.4s cubic-bezier(0.23, 1, 0.32, 1), top 0.4s cubic-bezier(0.23, 1, 0.32, 1)',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            boxShadow: '0px 0px 10px #aeaeae',
            borderRadius: '3px',
            color: 'rgb(87, 87, 87)',
            fontSize: '12px',
            fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
            lineHeight: '20px',
            padding: '10px 10px 6px 10px',
        },
        'g2-tooltip-title': {
            marginBottom: '4px',
        },
        'g2-tooltip-list': {
            margin: 0,
            listStyleType: 'none',
            padding: 0,
        },
        'g2-tooltip-list-item': {
            marginBottom: '4px',
        },
        'g2-tooltip-marker': {
            width: '5px',
            height: '5px',
            borderRadius: '50%',
            display: 'inline-block',
            marginRight: '8px',
        },
        'g2-tooltip-value': {
            display: 'inline-block',
            float: 'right',
            marginLeft: '30px',
        },
    },
    tooltipMarker: {
        stroke: '#fff',
        shadowBlur: 8,
        shadowOffsetX: 0,
        shadowOffSetY: 0,
        radius: 4,
    },
    tooltipCrosshairsRect: {
        type: 'rect',
        style: {
            fill: '#CCD6EC',
            opacity: 0.3,
        },
    },
    tooltipCrosshairsLine: {
        style: {
            stroke: 'rgba(0, 0, 0, 0.25)',
            lineWidth: 1,
        },
    },
    shape: {
        point: {
            lineWidth: 1,
            fill: '#1890FF',
            radius: 4,
        },
        hollowPoint: {
            fill: '#fff',
            lineWidth: 1,
            stroke: '#1890FF',
            radius: 3,
        },
        interval: {
            lineWidth: 0,
            fill: '#1890FF',
            fillOpacity: 0.85,
        },
        hollowInterval: {
            fill: '#fff',
            stroke: '#1890FF',
            fillOpacity: 0,
            lineWidth: 2,
        },
        area: {
            lineWidth: 0,
            fill: '#1890FF',
            fillOpacity: 0.3,
        },
        polygon: {
            lineWidth: 0,
            fill: '#1890FF',
            fillOpacity: 1,
        },
        hollowPolygon: {
            fill: '#fff',
            stroke: '#1890FF',
            fillOpacity: 0,
            lineWidth: 2,
        },
        hollowArea: {
            fill: '#fff',
            stroke: '#1890FF',
            fillOpacity: 0,
            lineWidth: 2,
        },
        line: {
            stroke: '#1890FF',
            lineWidth: 2,
            fill: null,
        },
        edge: {
            stroke: '#1890FF',
            lineWidth: 1,
            fill: null,
        },
        schema: {
            stroke: '#1890FF',
            lineWidth: 1,
            fill: null,
        },
    },
    guide: {
        line: {
            lineStyle: {
                stroke: '#1890FF',
                lineDash: [0, 2, 2],
                lineWidth: 1,
            },
            text: {
                position: 'end',
                autoRotate: true,
                style: {
                    fill: '#545454',
                    fontSize: 12,
                    textAlign: 'center',
                    fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
                },
            },
        },
        text: {
            style: {
                fill: '#545454',
                fontSize: 12,
                textBaseline: 'middle',
                textAlign: 'start',
                fontFamily: '"-apple-system", BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"',
            },
        },
        region: {
            style: {
                lineWidth: 0,
                fill: '#000',
                fillOpacity: 0.04,
            },
        },
        html: {
            alignX: 'middle',
            alignY: 'middle',
        },
    },
    pixelRatio: null,
};

var builtinG2Themes = {
    normal: normalTheme,
    yunzhi: yunzhiTheme,
    dark1: darkTheme,
    macarons: macaronsTheme,
};
function setConsoleTheme(key) {
    var theme = null;
    if (key) {
        if (typeof key === 'string') {
            theme = getConsoleTheme(key);
        }
        else {
            theme = key;
        }
    }
    else {
        theme = 'default';
    }
    if (!theme) {
        console.warn('主题设置错误');
        return;
    }
    // @ts-ignore
    G2.Global.setTheme(theme);
}
function registerConsoleTheme(themeKey, obj) {
    if (!isPlainObject_1(obj)) {
        console.warn('主题包必须设置为普通javascript对象');
        return;
    }
    builtinG2Themes[themeKey] = obj;
    // @ts-ignore
    G2.Global.registerTheme(themeKey, obj);
}
function getConsoleTheme(key) {
    key = key || 'default';
    if (builtinG2Themes[key]) {
        return builtinG2Themes[key];
    }
    else if (['default', 'dark'].includes(key)) {
        return key;
    }
    return null;
}

var consoleTheme = getConsoleTheme();
setConsoleTheme(consoleTheme);
// 图表唯一id
var uniqueId = 0;
function generateUniqueId() {
    return "console-chart-" + uniqueId++;
}
var rootClassName = 'console-chart-container';
var rootChildClassName = 'console-chart-children-container';
function g2Factory(chartName, chartProcessConfig) {
    var _a;
    var chartClassName = chartName.replace(/\B([A-Z])/g, "-$1").toLowerCase();
    return _a = /** @class */ (function (_super) {
            __extends(ConsoleChartFactory, _super);
            function ConsoleChartFactory() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.reRenderTimer = null;
                _this.resizeRunning = false;
                _this.resizeTimer = null;
                _this.consoleTheme = G2.Global;
                _this.isReRendering = false;
                _this.autoResize = function () {
                    if (_this.resizeRunning) {
                        window.cancelAnimationFrame(_this.resizeTimer);
                        return;
                    }
                    var _a = _this, element = _a.chartDom, props = _a.props, chartSize = _a.chartSize;
                    _this.resizeRunning = true;
                    _this.resizeTimer = requestAnimationFrame.call(window, function () {
                        _this.resizeRunning = false;
                        var parentSize = getParentSize(element, props.width, props.height);
                        // 读取的高宽需要是有效值，0 也不可以
                        if (parentSize[0] && parentSize[1] && !(parentSize[0] === chartSize[0] && parentSize[1] === chartSize[1])) {
                            _this.changeSize(props.config, parentSize[0], parentSize[1]);
                            _this.afterRender(_this.unifiedProps.config);
                        }
                    });
                };
                return _this;
            }
            ConsoleChartFactory.prototype.componentDidMount = function () {
                var unifiedProps = chartProcessConfig.getUnifiedProps ? chartProcessConfig.getUnifiedProps(this.props) : this.props;
                this.unifiedProps = unifiedProps;
                this.initChart(unifiedProps);
            };
            ConsoleChartFactory.prototype.componentDidUpdate = function (prevProps) {
                var unifiedProps = prevProps;
                var nextUnifiedProps = this.props;
                if (chartProcessConfig.getUnifiedProps) {
                    unifiedProps = chartProcessConfig.getUnifiedProps(prevProps);
                    nextUnifiedProps = chartProcessConfig.getUnifiedProps(this.props);
                }
                this.unifiedProps = nextUnifiedProps;
                var oldData = unifiedProps.data, oldWidth = unifiedProps.width, oldHeight = unifiedProps.height, oldConfig = unifiedProps.config;
                var newData = nextUnifiedProps.data, newWidth = nextUnifiedProps.width, newHeight = nextUnifiedProps.height, newConfig = nextUnifiedProps.config, forceUpdate = nextUnifiedProps.forceUpdate, _a = nextUnifiedProps.changeConfig, changeConfig = _a === void 0 ? true : _a;
                if (forceUpdate || Updater.needRebuildChart(unifiedProps, nextUnifiedProps)) {
                    this.reInitChart(unifiedProps, nextUnifiedProps);
                    return;
                }
                var changeCustomConfig = chartProcessConfig.changeCustomConfig;
                // 配置项有变化，重新生成图表
                if (changeConfig !== false) {
                    var needRedraw = false;
                    if (changeCustomConfig && !isEqualWith_1(newConfig, oldConfig, changeCustomConfig.bind(this))) {
                        needRedraw = true;
                    }
                    else if (!changeCustomConfig && !isEqual_1(newConfig, oldConfig)) {
                        needRedraw = true;
                    }
                    else if (!isEqual_1(newData, oldData)) {
                        // 数据不相同, 由于情况比较复杂， 这里直接就重新渲染了。
                        needRedraw = true;
                    }
                    if (needRedraw) {
                        this.chart.clear();
                        var config = nextUnifiedProps.config;
                        chartProcessConfig.drawChart.call(this, this.chart, config, newData);
                    }
                }
                // 传入的长宽有变化
                if (newWidth !== oldWidth || newHeight !== oldHeight) {
                    this.changeSize(newConfig, newWidth, newHeight);
                }
                this.chart.repaint();
                this.afterRender(newConfig);
            };
            ConsoleChartFactory.prototype.componentWillUnmount = function () {
                this.destroyChart();
            };
            ConsoleChartFactory.prototype.initChart = function (nextUnifiedProps) {
                // 开始初始化图表
                this.initSize(nextUnifiedProps);
                var initData = nextUnifiedProps.data, padding = nextUnifiedProps.padding, width = nextUnifiedProps.width, height = nextUnifiedProps.height, forceFit = nextUnifiedProps.forceFit, config = nextUnifiedProps.config, event = nextUnifiedProps.event, otherProps = __rest(nextUnifiedProps, ["data", "padding", "width", "height", "forceFit", "config", "event"]);
                var canvasWidth = width || this.chartSize[0];
                var canvasHeight = height || this.chartSize[1];
                // 生成图表实例
                var chart = new G2.Chart(__assign({ container: this.chartDom, width: canvasWidth, height: canvasHeight, padding: padding, forceFit: forceFit || false }, otherProps));
                // 预处理数据
                chart && chartProcessConfig.drawChart.call(this, chart, config, initData);
                if (chart && event) {
                    Object.keys(event).forEach(function (eventKey) {
                        chart.on(eventKey, event[eventKey]);
                    });
                }
                this.chart = chart;
                if (isFunction$1(nextUnifiedProps.onGetG2Instance)) {
                    nextUnifiedProps.onGetG2Instance(chart);
                }
                this.afterRender(nextUnifiedProps.config);
            };
            // 初始化时适配高宽
            ConsoleChartFactory.prototype.initSize = function (props) {
                var currentProps = props || this.props;
                var element = this.chartDom;
                var parentSize = getParentSize(element, currentProps.width, currentProps.height);
                this.setSize(parentSize[0], parentSize[1]);
                window.addEventListener('resize', this.autoResize);
            };
            ConsoleChartFactory.prototype.changeSize = function (config, w, h) {
                if (w === void 0) { w = this.chartSize[0]; }
                if (h === void 0) { h = this.chartSize[1]; }
                this.setSize(w, h);
                if (chartProcessConfig.changeSize) {
                    this.chart && chartProcessConfig.changeSize.call(this, this.chart, config, w, h);
                }
                else {
                    this.chart && this.chart.changeSize(w, h);
                }
            };
            // 设置高宽
            ConsoleChartFactory.prototype.setSize = function (width, height) {
                var element = this.chartDom;
                if (!element)
                    return;
                if (width) {
                    element.style.width = width + "px";
                }
                if (height) {
                    element.style.height = height + "px";
                }
                this.chartSize = [width, height];
            };
            ConsoleChartFactory.prototype.afterRender = function (config) {
                if (this.chart && chartProcessConfig.afterRender) {
                    chartProcessConfig.afterRender.call(this, this.chart, config || this.props.config);
                }
            };
            ConsoleChartFactory.prototype.reInitChart = function (unifiedProps, nextUnifiedProps) {
                var _this = this;
                if (this.chart == null)
                    return;
                var forceUpdate = nextUnifiedProps.forceUpdate;
                if (forceUpdate || Updater.needRebuildChart(unifiedProps, nextUnifiedProps)) {
                    if (this.isReRendering) {
                        window.cancelAnimationFrame(this.reRenderTimer);
                    }
                    this.isReRendering = true;
                    this.destroyChart();
                    this.reRenderTimer = requestAnimationFrame.call(window, function () {
                        if (!_this.chartDom) {
                            return;
                        }
                        _this.initChart(nextUnifiedProps);
                        _this.isReRendering = false;
                    });
                }
            };
            ConsoleChartFactory.prototype.destroyChart = function () {
                // 清空缩放相关变量和事件
                this.resizeRunning = false;
                this.resizeTimer = null;
                window.removeEventListener('resize', this.autoResize);
                // 清除配置变化重新生成图表的定时器
                window.cancelAnimationFrame(this.reRenderTimer);
                if (chartProcessConfig.destroy) {
                    this.chart && chartProcessConfig.destroy.call(this, this.chart);
                }
                this.chart && this.chart.destroy && this.chart.destroy();
                this.chart = null;
                if (isFunction$1(this.props.onGetG2Instance)) {
                    this.props.onGetG2Instance(null);
                }
            };
            ConsoleChartFactory.prototype.render = function () {
                var _this = this;
                var _a = this.props, className = _a.className, style = _a.style, children = _a.children;
                return (createElement("div", { ref: function (dom) { return (_this.chartDom = dom); }, id: ConsoleChartFactory.chartId, key: ConsoleChartFactory.chartId, className: rootClassName + " " + chartName + " " + chartClassName + " " + className, style: style }, children ? createElement("div", { className: rootChildClassName }, children) : null));
            };
            return ConsoleChartFactory;
        }(Component)),
        _a.displayName = chartName,
        _a.chartId = generateUniqueId(),
        _a;
}

var consoleDefaultConfig = {
    ConsoleLineChart: {},
    ConsoleBarChart: {},
    ConsoleComboChart: {},
    ConsolePieChart: {},
    ConsoleMinilineChart: {
        padding: [0, 0, 0, 0],
        xAxis: {},
        yAxis: {},
        tooltip: false,
        area: false,
        smooth: false,
        symbol: false,
        label: false,
    },
    ConsoleRadarChart: {
        xAxis: {
            label: {},
            line: null,
            tickLine: null,
            grid: {
                lineStyle: {
                    lineDash: null,
                },
            },
        },
        yAxis: {
            label: {
                offset: 8,
                textStyle: {
                    textAlign: 'right',
                },
            },
            line: null,
            tickLine: null,
            grid: {
                type: 'polygon',
                lineStyle: {
                    lineDash: null,
                },
            },
        },
    },
    ConsoleFunnelChart: {},
    ConsoleDotChart: {},
    ConsoleRoseChart: {},
};

var consoleYunzhiConfig = {
    ConsoleLineChart: {},
    ConsoleBarChart: {},
    ConsoleComboChart: {},
    ConsolePieChart: {},
    ConsoleMinilineChart: {},
    ConsoleRadarChart: {},
    ConsoleFunnelChart: {},
    ConsoleDotChart: {},
    ConsoleRoseChart: {},
};

var consoleConfigMap = {
    default: consoleDefaultConfig,
    yunzhi: consoleYunzhiConfig,
};
var CONSOLE_CONFIG_KEY = 'console_config_key';
var CONSOLE_DEFAULT_CONFIG_KEY = 'default';
function setConsoleConfig(key) {
    if (!key) {
        return;
    }
    try {
        window.localStorage.setItem(CONSOLE_CONFIG_KEY, key);
    }
    catch (e) { }
}
function getConsoleConfig(key) {
    var consoleConfigKey = null;
    try {
        consoleConfigKey = window.localStorage.getItem(CONSOLE_CONFIG_KEY);
    }
    catch (e) { }
    key = key || consoleConfigKey;
    return Object.assign(consoleConfigMap[CONSOLE_DEFAULT_CONFIG_KEY], consoleConfigMap[key]);
}

export { index as Constants, utils as Utils, adaptData, axisX, axisY, beautifyNumber, computePadding, dataAdapter, defaultPadding, drawLine, filterKey, formatPadding, g2Factory, guide as g2Guide, label as g2Label, legend as g2Legend, g2Size, g2Style, tooltip as g2Tooltip, getConsoleConfig, getConsoleTheme, getDataIndexColor, getFinalGeomColors, getParentSize, getRawData, getStatusColor, getStatusColorName, isInvalidNumber, noop, numberDecimal, propertyAssign, propertyMap, pxToNumber, rectAutoTickCount, registerConsoleTheme, requestAnimationFrame, setConsoleConfig, setConsoleTheme, stylePadding };
